import { PackagesProps } from "../types/packages";

import BetoCarrero from "../assets/images/packages/beto-carrero/castelo.png";
import BetoCarreroH from "../assets/images/packages/beto-carrero/castelo-horizontal.png";
import BetoCarreroL from "../assets/images/packages/beto-carrero/lamina beto carrero ferias 2027.png";
import betocarreroPdf from "../assets/pdfs/Beto Carrero janeiro 2027.pdf";

import Fln from "../assets/images/packages/florianopolis/FLN.png";
import FlnH from "../assets/images/packages/florianopolis/FLN-h.png";
import FlnL from "../assets/images/packages/florianopolis/lamina florianopolis.png";
import FlnPdf from "../assets/pdfs/Florianopolis.pdf";

import BeloHorizonte from "../assets/images/packages/Belo horizonte/bh.png";
import BeloHorizonteH from "../assets/images/packages/Belo horizonte/bh-h.png";
import BeloHorizonteL from "../assets/images/packages/Belo horizonte/lamina belo horizonte.png";
import BeloHorizontePdf from "../assets/pdfs/minas gerais.pdf";

import BetoCarreroPromo from "../assets/images/packages/beto-carrero/betocarrero1.png";
import BetoCarreroPromoH from "../assets/images/packages/beto-carrero/betocarrero1-h.png";
import BetoCarreroPromoL from "../assets/images/packages/beto-carrero/lamina-betocarrero-promo.png";
import BetoCarreroPromoPdf from "../assets/pdfs/betocarrero-promo.pdf";

import BetoCarreroFeriado from "../assets/images/packages/beto-carrero/betocarrero2.png";
import BetoCarreroFeriadoH from "../assets/images/packages/beto-carrero/betocarrero2-h.png";
import BetoCarreroFeriadoL from "../assets/images/packages/beto-carrero/lamina-betocarrero-feriado.png";
import BetoCarreroFeriadoPdf from "../assets/pdfs/beto carrero independencia.pdf";

import VilaGale from "../assets/images/packages/vilagale-cumbuco/lamina-vilagale.png";
import VilaGaleH from "../assets/images/packages/vilagale-cumbuco/vilagale1-h.png";
import VilaGaleL from "../assets/images/packages/vilagale-cumbuco/lamina-vilagale.png";
import VilaGalePdf from "../assets/pdfs/vila gale abril.pdf";

import LagosAndinos from "../assets/images/packages/Lagos Andinos/lagosandinos.png";
import LagosAndinosH from "../assets/images/packages/Lagos Andinos/lagosandinos-h.png";
import LagosAndinosL from "../assets/images/packages/Lagos Andinos/lamina lagos andinos.png";
import LagosAndinosPdf from "../assets/pdfs/lagos andinos.pdf";

import GramadoBaixa from "../assets/images/packages/gramado/gramado3.png";
import GramadoBaixaH from "../assets/images/packages/gramado/gramado3-h.png";
import GramadoBaixaL from "../assets/images/packages/gramado/lamina gramado baixa temporada.png";
import GramadoBaixaPdf from "../assets/pdfs/GRAMADO 2026 - BAIXA TEMPORADA.pdf";


import Noronha from "../assets/images/packages/fernando de noronha/noronha.png";
import NoronhaH from "../assets/images/packages/fernando de noronha/noronha-h.png";
import NoronhaL from "../assets/images/packages/fernando de noronha/lamina fen ferias 2027.png";
import NoronhaPdf from "../assets/pdfs/fernando de noronha ferias 2027.pdf";

import GramadoFerias2027 from "../assets/images/packages/gramado/Gramado2.png";
import GramadoFerias2027H from "../assets/images/packages/gramado/Gramado2-h.png";
import GramadoFerias2027L from "../assets/images/packages/gramado/lamina gramado ferias 2027.png";
import GramadoFerias2027Pdf from "../assets/pdfs/Gramado ferias 2027.pdf";

import GramadoJulho2026 from "../assets/images/packages/natal-luz-gramado/gramado.png";
import GramadoJulho2026H from "../assets/images/packages/natal-luz-gramado/gramado-horizontal.png";
import GramadoJulho2026L from "../assets/images/packages/gramado/lamina ferias julho 2026.png";
import GramadoJulho2026Pdf from "../assets/pdfs/gramado julho 2026.pdf";

import BelemeMarajo from "../assets/images/packages/belem-marajo/Ilha_de_Marajo.png";
import BelemeMarajoH from "../assets/images/packages/belem-marajo/ilha_de_Marajo-2.png";
import BelemeMarajoL from "../assets/images/packages/belem-marajo/lamina belem e marajo.png";
import BelemeMarajoPdf from "../assets/pdfs/BELEM COM ILHA DO MARAJO.pdf";

import Turquia from "../assets/images/packages/turquia/turquia.png";
import TurquiaH from "../assets/images/packages/turquia/turquia h.png";
import TurquiaL from "../assets/images/packages/turquia/lamina lendas da turquia.png";
import TurquiaPdf from "../assets/pdfs/LENDAS DA TURQUIA.pdf";

import TurquiaDubai from "../assets/images/packages/turquia/turquia2.png";
import TurquiaDubaiH from "../assets/images/packages/turquia/turquia2 h.png";
import TurquiaDubaiL from "../assets/images/packages/turquia/lamina turquia dubai e grecia.png";
import TurquiaDubaiPdf from "../assets/pdfs/TURQUIA GRECIA E DUBAI.pdf";

import FozCompras from "../assets/images/packages/foz-do-iguacu/foz.png";
import FozComprasH from "../assets/images/packages/foz-do-iguacu/foz-horizontal.png";
import FozComprasL from "../assets/images/packages/foz-do-iguacu/lamina foz compras de natal.png";
import FozComprasPdf from "../assets/pdfs/compras de natal foz do iguacu.pdf";

import FozBaixa from "../assets/images/packages/foz-baixatemporada/foz-baixa.png";
import FozBaixaH from "../assets/images/packages/foz-baixatemporada/foz-baixa-h.png";
import FozBaixaL from "../assets/images/packages/foz-do-iguacu/lamina foz promocional.png";
import FozBaixaPdf from "../assets/pdfs/FOZ DO IGUAÇU PROMOCIONAL.pdf";

import FozJulho from "../assets/images/packages/foz-do-iguacu/igu.png";
import FozJulhoH from "../assets/images/packages/foz-do-iguacu/igu-h.png";
import FozJulhoL from "../assets/images/packages/foz-do-iguacu/lamina foz julho.png";
import FozJulhoPdf from "../assets/pdfs/foz julho.pdf";

import Morro2027 from "../assets/images/packages/morro-sao-paulo/morro-sp.png";
import Morro2027H from "../assets/images/packages/morro-sao-paulo/morro-sp-h.png";
import Morro2027L from "../assets/images/packages/morro-saopaulo/lamina morro sp jan 2027.png";
import Morro2027Pdf from "../assets/pdfs/Morro de SP Jan 2027.pdf";

import Jeri2027 from "../assets/images/packages/jericoacoara/jeri.png";
import Jeri2027H from "../assets/images/packages/jericoacoara/jeri-2.png";
import Jeri2027L from "../assets/images/packages/jericoacoara/lamina-jeri jan 2027.png";
import Jeri2027Pdf from "../assets/pdfs/Jeri jan 2027.pdf";

import MorroJan from "../assets/images/packages/morro-saopaulo/morrospjan.png";
import MorroJanH from "../assets/images/packages/morro-saopaulo/morrospjan-h.png";
import MorroJanL from "../assets/images/packages/morro-saopaulo/lamina morro sp.png";
import MorroJanPdf from "../assets/pdfs/MORRO DE SP JANEIRO 2026.pdf";


import NatalIndependencia from "../assets/images/packages/natal/NATAL-JANEIRO.png";
import NatalIndependenciaH from "../assets/images/packages/natal/NATAL-JANEIRO-H.png";
import NatalIndependenciaL from "../assets/images/packages/natal/Lamina natal Feriado independencia.png";
import NatalIndependenciaPdf from "../assets/pdfs/Natal feriado da independencia.pdf";

import Manaus from "../assets/images/packages/Manaus/Manaus.png";
import ManausH from "../assets/images/packages/Manaus/Manaus-h.png";
import ManausL from "../assets/images/packages/Manaus/lamina manaus.png";
import ManausPdf from "../assets/pdfs/MANAUS.pdf";

import JapaoeCoreia from "../assets/images/packages/Japao/japao.png";
import JapaoeCoreiaH from "../assets/images/packages/Japao/japao-h.png";
import JapaoeCoreiaL from "../assets/images/packages/Japao/lamina japao e coreia.png";
import JapaoeCoreiaPdf from "../assets/pdfs/Japao Coreia e Qatar.pdf";

import BonitoSet from "../assets/images/packages/bonito/bonito.png";
import BonitoSetH from "../assets/images/packages/bonito/bonito-h.png";
import BonitoSetL from "../assets/images/packages/bonito/lamina-bonito-set.png";
import BonitoSetPdf from "../assets/pdfs/BONITO SET.pdf";

import BonitoPromo from "../assets/images/packages/bonito/Bonito2.png";
import BonitoPromoH from "../assets/images/packages/bonito/Bonito2-h.png";
import BonitoPromoL from "../assets/images/packages/bonito/lamina bonito.png";
import BonitoPromoPdf from "../assets/pdfs/Bonito.pdf";

import CamposJordao from "../assets/images/packages/campos-do-jordao/campos.png";
import CamposJordaoH from "../assets/images/packages/campos-do-jordao/campos-h.png";
import CamposJordaoL from "../assets/images/packages/campos-do-jordao/lamina-campos-jordao.png";
import CamposJordaoPdf from "../assets/pdfs/Campos-do-jordao-julho.pdf";

import FazzendaJulho from "../assets/images/packages/fazzenda-park/CWB.png";
import FazzendaJulhoH from "../assets/images/packages/fazzenda-park/CWB-h.png";
import FazzendaJulhoL from "../assets/images/packages/fazzenda-park/lamina-fazzenda-park-julho.png";
import FazzendaJulhoPdf from "../assets/pdfs/fazzenda-park-julho.pdf";

import RotaEmocoes from "../assets/images/packages/jericoacoara/jericoacoara.png";
import RotaEmocoesH from "../assets/images/packages/jericoacoara/jericoacoara-h.png";
import RotaEmocoesL from "../assets/images/packages/jericoacoara/lamina-rota-das-emocoes.png";
import RotaEmocoesPdf from "../assets/pdfs/rota-das-emocoes.pdf";

import RotaEmocoes2 from "../assets/images/packages/Rotadasemocoes/lencois.png";
import RotaEmocoes2H from "../assets/images/packages/Rotadasemocoes/lencois-h.png";
import RotaEmocoes2L from "../assets/images/packages/Rotadasemocoes/lamina rota das emocoes.png";
import RotaEmocoes2Pdf from "../assets/pdfs/info rota as emocoes.pdf";

import Aracaju from "../assets/images/packages/aracaju/aracaju.png";
import AracajuH from "../assets/images/packages/aracaju/aracaju-h.png";
import AracajuL from "../assets/images/packages/aracaju/lamina-aracaju-novembro.png";
import AracajuPdf from "../assets/pdfs/aracaju-setembro.pdf";

import AracajuSep from "../assets/images/packages/aracaju/aracaju2.png";
import AracajuSepH from "../assets/images/packages/aracaju/aracaju2-h.png";
import AracajuSepL from "../assets/images/packages/aracaju/lamina-aracaju-07setembro.png";
import AracajuSepPdf from "../assets/pdfs/aracaju-07setembro.pdf";

import Jalapao from "../assets/images/packages/jalapao/jalapao.png";
import JalapaoH from "../assets/images/packages/jalapao/jalapao-h.png";
import JalapaoL from "../assets/images/packages/jalapao/lamina jalapao corpus christi.png";
import JalapaoPdf from "../assets/pdfs/JALAPAO CORPUS CHRISTI.pdf";

import Santarem from "../assets/images/packages/santarem/alter-do-chao.png";
import SantaremH from "../assets/images/packages/santarem/alter-do-chao-h.png";
import SantaremL from "../assets/images/packages/santarem/lamina-santarem.png";
import SantaremPdf from "../assets/pdfs/santarem.pdf";

import MSCJan from "../assets/images/packages/msc/msc.png";
import MSCJanH from "../assets/images/packages/msc/msc-horizontal.png";
import MSCJanL from "../assets/images/packages/msc/lamina-MSC.png";
import MSCJanPdf from "../assets/pdfs/MSC-JANEIRO.pdf";

import JoaoPessoa from "../assets/images/packages/joao-pessoa/joao-pessoa.png";
import JoaoPessoaH from "../assets/images/packages/joao-pessoa/joao-pessoa-h.png";
import JoaoPessoaL from "../assets/images/packages/joao-pessoa/lamina-joao-pessoa-abril.png";
import JoaoPessoaPdf from "../assets/pdfs/joao pessoa abril.pdf";

import Colombia from "../assets/images/packages/Colombia/colombia.png";
import ColombiaH from "../assets/images/packages/Colombia/colombia-h.png";
import ColombiaL from "../assets/images/packages/Colombia/lamina colombia.png";
import ColombiaPdf from "../assets/pdfs/colombia.pdf";

import PglPromo from "../assets/images/packages/porto-de-galinhas/Porto_de_Galinhas-h.png";
import PglPromoH from "../assets/images/packages/porto-de-galinhas/Porto_de_Galinhas.png";
import PglPromoL from "../assets/images/packages/porto-de-galinhas/lamina-pgl-baixa2026.png";
import PglPromoPdf from "../assets/pdfs/porto de galinhas feb 2026.pdf";

import MelhorDoRecife from "../assets/images/packages/recife/recife.png";
import MelhorDoRecifeH from "../assets/images/packages/recife/recife-horizontal.png";
import MelhorDoRecifeL from "../assets/images/packages/recife/lamina recife e trem.png";
import MelhorDoRecifePdf from "../assets/pdfs/recife e trem.pdf";

import Pgl2027 from "../assets/images/packages/porto-de-galinhas/PGL-3.png";
import Pgl2027H from "../assets/images/packages/porto-de-galinhas/PGL-3H.png";
import Pgl2027L from "../assets/images/packages/porto-de-galinhas/lamina pgl jan 27.png";
import Pgl2027Pdf from "../assets/pdfs/Porto de galinhas jan 2027.pdf";

import PglBaixa from "../assets/images/packages/porto-de-galinhas/Pgl2026.png";
import PglBaixaH from "../assets/images/packages/porto-de-galinhas/Pgl2026-h.png";
import PglBaixaL from "../assets/images/packages/porto-de-galinhas/lamina-pgl-baixa.png";
import PglBaixaPdf from "../assets/pdfs/PORTO GALINHAS BAIXA.pdf";

import Lencois from "../assets/images/packages/lencois-maranhenses/lencois2.png";
import LencoisH from "../assets/images/packages/lencois-maranhenses/lencois2-h.png";
import LencoisL from "../assets/images/packages/lencois-maranhenses/lamina-lencois-abril.png";
import LencoisPdf from "../assets/pdfs/lencois abril.pdf";

import GramadoOMelhor from "../assets/images/packages/gramado/Gramado2.png";
import GramadoOMelhorH from "../assets/images/packages/gramado/Gramado2-h.png";
import GramadoOMelhorL from "../assets/images/packages/gramado/lamina gramado natal luz primeira saida.png";
import GramadoOMelhorPdf from "../assets/pdfs/PRIMEIRA SAIDA NATAL LUZ 2026.pdf";

import NatalLuz02saida from "../assets/images/packages/natal-luz-gramado/Natal-gramado.png";
import NatalLuz02saidaH from "../assets/images/packages/natal-luz-gramado/Natal-gramado-h.png";
import NatalLuz02saidaL from "../assets/images/packages/gramado/lamina gramado natal luz primeira saida.png";
import NatalLuz02saidaPdf from "../assets/pdfs/SEGUNDA SAIDA NATAL LUZ 2026.pdf";

import Fortaleza from "../assets/images/packages/fortaleza/fortaleza-janeiro.png";
import FortalezaH from "../assets/images/packages/fortaleza/fortaleza-janeiro-h.png";
import FortalezaL from "../assets/images/packages/fortaleza/lamina-fortaleza-abril.png";
import FortalezaPdf from "../assets/pdfs/fortaleza abril.pdf";

import Arraial from "../assets/images/packages/arraial dajuda/arraial.png";
import ArraialH from "../assets/images/packages/arraial dajuda/arraial-h.png";
import ArraialL from "../assets/images/packages/arraial dajuda/lamina-arrail-out.png";
import ArraialPdf from "../assets/pdfs/ARRAIAL OUT.pdf";

import Bariloche from "../assets/images/packages/bariloche/bariloche.png";
import BarilocheH from "../assets/images/packages/bariloche/bariloche-h.png";
import BarilocheL from "../assets/images/packages/bariloche/lamina bariloche.png";
import BarilochePdf from "../assets/pdfs/bariloche.pdf";

import Maceio from "../assets/images/packages/maceio/maceio.png";
import MaceioH from "../assets/images/packages/maceio/maceio-horizontal.png";
import MaceioL from "../assets/images/packages/maceio/lamina maceio feriado independencia.png";
import MaceioPdf from "../assets/pdfs/maceio feriado da independencia.pdf";

import CaldasNovas from "../assets/images/packages/caldas novas/caldas-novas.png";
import CaldasNovasH from "../assets/images/packages/caldas novas/caldas-novas-h.png";
import CaldasNovasL from "../assets/images/packages/caldas novas/lamina caldas novas.png";
import CaldasNovasPdf from "../assets/pdfs/caldas novas.pdf";

import NatalCWB from "../assets/images/packages/curitiba/Natal-Disney.png";
import NatalCWBH from "../assets/images/packages/curitiba/Natal Disney-h.png";
import NatalCWBL from "../assets/images/packages/curitiba/lamina natal curitiba 2.png";
import NatalCWBPdf from "../assets/pdfs/Natal curitiba 2026.pdf";

export enum SlideType {
  nacional,
  internacional,
  bloqueio,
  navio,
}

export const packages: PackagesProps[] = [


  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Fortaleza (CE) - Férias N.S da Penha",
    period: "04 noites",
    initialDate: "09/04/2026",
    finalDate: "13/04/2026",
    parcelValue: 141.0,
    qtdParcel: 12,
    entry: 528.0,
    value: 2156.58,
    include: [
      "Passagem aérea Vitoria x Fortaleza x Vitoria com a Latam com direito a 01 mala de até 10 Kg;",
      "04 Noites de Hospedagem conforme escolha;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "Passeio Morro Branco e Fontes - Regular;",
      "Seguro viagem.",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros (passando maquininha empresa)",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
    ],
    image: Fortaleza,
    imageH: FortalezaH,
    lamina: FortalezaL,
    pdf: FortalezaPdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Fernando de Noronha (CE) - Férias de Janeiro 2027",
    period: "05 noites",
    initialDate: "20/01/2027",
    finalDate: "25/01/2027",
    parcelValue: 382.0,
    qtdParcel: 12,
    entry: 1487.0,
    value: 5892.00,
    include: [
      "Passagem Aérea ida e volta com franquia de bagagem de 10kg;",
      "05 Noites de hospedagem com café da manhã;",
      "Transfer in/out - Aeroporto x Hotel x Aeroporto;",
      "Passeio de Ilhatur de ponta a ponta ao retorno de Noronha;",
      "Seguro viagem.",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros (passando maquininha empresa)",
      "Entrada de 25% (Pix) + Parcelamento Via Link em até 10 vezes s/juros(link) / Parcelamento Via Cartão de crédito em até 12 vezes maquineta loja / 15 Vezes s/juros no Boleto (Sujeito Analise Bancaria)",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
      "Consulte-nos valores e disponibilidade de outros hotéis de acordo com a necessidade do cliente.",
      "Valores não incluem Taxa e Preservação Ambiental (TPA) VALOR POR PESSOA - R$ 101,33 E POR DIA , Sujeito a alteração e pagamento via si- te da do governo ou localmente.",
      "Valores não incluem Taxas do Parque Nacional Marinho (PARNAMAR), é cobrado para especificas do parque o valor de R$ 186,50 por pessoa Brasileiro ,Sujeito a alteração e pagamento no local.",
    ],
    image: Noronha,
    imageH: NoronhaH,
    lamina: NoronhaL,
    pdf: NoronhaPdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Natal (RN) - Feriado da Independência + Feriado Vitória ",
    period: "04 noites",
    initialDate: "04/09/2026",
    finalDate: "08/09/2026",
    parcelValue: 249.0,
    qtdParcel: 12,
    entry: 962.50,
    value: 3834.0,
    include: [
      "Passagem aérea Vitoria x Natal x Vitoria com a Latam com Bagagem de 10 kg;",
      "04 Noites de Hospedagem conforme escolha com cafe;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "City Tour em Natal + Praia de Camurupim;",
      "Seguro viagem.",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros (passando maquininha empresa)",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
    ],
    image: NatalIndependencia,
    imageH: NatalIndependenciaH,
    lamina: NatalIndependenciaL,
    pdf: NatalIndependenciaPdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Manaus (AM) - Feriado da Independência + Feriado Vitória ",
    period: "04 noites",
    initialDate: "04/09/2026",
    finalDate: "08/09/2026",
    parcelValue: 295.0,
    qtdParcel: 12,
    entry: 990.0,
    value: 4394.0,
    include: [
      "Passagem aerea ida e volta com franquia de bagagem de 10Kg;",
      "04 Noites de Hospedagem com café da manhã conforme opções;",
      "Transfer in/out - Aeroporto x hotel x Aeroporto;",
      "City tour Manaus;",
      "Seguro viagem.",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros (passando maquininha empresa)",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
    ],
    image: Manaus,
    imageH: ManausH,
    lamina: ManausL,
    pdf: ManausPdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Porto de Galinhas (PE) - Férias de janeiro 2027",
    period: "04 noites",
    initialDate: "17/01/2027",
    finalDate: "21/01/2027",
    parcelValue: 219.0,
    qtdParcel: 12,
    entry: 850.0,
    value: 3377.0,
    include: [
      "Aéreo Vitoria x Recife x Vitoria com a Gol com direito a 01 mala de até 10 kg;",
      "04 noites conforme hotel escolhido + café da manhã;",
      "Traslados Aeroporto x hotel x aeroporto;",
      "Seguro viagem",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros (passando maquininha empresa)",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
    ],
    image: Pgl2027,
    imageH: Pgl2027H,
    lamina: Pgl2027L,
    pdf: Pgl2027Pdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Vila Galé Cumbuco (CE) - Feriado N.s da Penha",
    period: "04 noites",
    initialDate: "09/04/2026",
    finalDate: "13/04/2026",
    parcelValue: 343.0,
    qtdParcel: 12,
    entry: 900.0,
    value: 4868.70,
    include: [
      "Passagem aérea Vitoria x Fortaleza x Vitoria com a Latam com direito a 01 mala de até 10 Kg;",
      "04 Noites de Hospedagem no Hotel Vila Gale Cumbuco em apto com sistema All inclusive;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "Seguro viagem"      
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
    ],
    image: VilaGale,
    imageH: VilaGaleH,
    lamina: VilaGaleL,
    pdf: VilaGalePdf,
    dayByDay: [],
  },


  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Beto Carrero - Ferias de Janeiro 2027",
    period: "04 noites",
    initialDate: "17/01/2027",
    finalDate: "21/07/2027",
    parcelValue: 197.0,
    qtdParcel: 12,
    entry: 950.0,
    value: 3180.0,
    include: [
      "Aéreo Vitoria x Navegantes x Vitoria com direito a 01 mala de até 10 kg;",
      "04 noites conforme hotel escolhido + café da manhã;",
      "Traslados Aeroporto x hotel x aeroporto + 02 dias de parque com ingresso e traslados;",
      "Seguro de viagem",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros (passando maquininha empresa)",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
    ],
    image: BetoCarrero,
    imageH: BetoCarreroH,
    lamina: BetoCarreroL,
    pdf: betocarreroPdf,
    dayByDay: [],
  },

    {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Beto Carrero - Feriado da Independência",
    period: "4 noites",
    initialDate: "04/09/2026",
    finalDate: "08/09/2025",
    parcelValue: 214.0,
    qtdParcel: 12,
    entry: 820.0,
    value: 3289.0,
    include: [
      "Aéreo Vitoria x Navegantes x Vitoria com a Gol com direito a 01 mala de até 10 kg;",
      "04 noites conforme hotel escolhido + café da manhã;",
      "Traslados Aeroporto x hotel x aeroporto + 02 dias de parque com ingresso e traslados;",
      "Seguro de viagem",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros (passando maquininha empresa)",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
    ],
    image: BetoCarreroFeriado,
    imageH: BetoCarreroFeriadoH,
    lamina: BetoCarreroFeriadoL,
    pdf: BetoCarreroFeriadoPdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Campos do Jordão (SP) - Especial de Inverno",
    period: "04 noites",
    initialDate: "16/07/2025",
    finalDate: "20/07/2025",
    parcelValue: 396.0,
    qtdParcel: 12,
    entry: 0.0,
    value: 4672.0,
    include: [
      "Passagem Aérea Vitoria x Guarulhos x Vitoria com a Latam com bagagem de 10 kg;",
      "04 Noites de Hospedagem em Campos do Jordão na Pousada das Hortênsias em apto Luxo com café da manhã e Chá da Tarde incluso - https://dashortensias.com.br;",
      "Traslados aeroporto x Hotel x aeroporto - Privado;",
      "Seguro viagem."      
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
      "Valor da taxa de embarque R$ 80,00 por pessoa deverá ser adicionado acima.",
    ],
    policy: [
      "Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
    ],
    image: CamposJordao,
    imageH: CamposJordaoH,
    lamina: CamposJordaoL,
    pdf: CamposJordaoPdf,
    dayByDay: [],
  },

  {
    type: SlideType.internacional,
    title: "Japão, Coréia & Qatar 2027",
    period: "22 noites",
    initialDate: "18/03/2027",
    finalDate: "10/04/2027",
    parcelValue: 825.0,
    qtdParcel: 10,
    entry: 4440.0,
    value: 12690.0,
    include: [
      "Passagem aérea ida e volta com Franquia de bagagem de 10kg e 23Kg;",
      "18 a 19/03 & 11 a 12/04 - 02 Noites de Hospedagem com café da manhã em Guarulhos c/Transfer;",
      "22 Noites de Hospedagem em Hotéis Categoria Superiores com café da manhã incluindo uma noite;",
      "tradicional Ryokan Japonês com experiencia de banho terma (Onsen);",
      "Café da manhã diário, Almoços e Jantares conforme programação incluindo uma autentica experiencia gastronômica em um tradicional Ryokan Japonês. Conforme todas as refeições indicadas no roteiro;",
      "Todos os traslados de chegada e saída;",
      "Trem de alta velocidade KTX entre Seul x Busan. Bilhetes de Shinkansen (Trem Bala) conforme programação;",
      "Transporte de bagagem entre Kyoto e Toquio com limite de 1 mala por pessoa;",
      "City tour panorâmico em Doha, visitas completas em Seul, Susan, Gyeongiu, Osaka, Nara, Kyoto Takayama, Tsumago, Hakone e Toquio;",
      "Cruzeiro pelo Lago Ashi;",
      "Teleférico do Monte Komagatake, Passeio no Haeundar Beach Train;",
      "Entradas para todos os monumentos, templos, castelos, jardins, museus e atrações Previstas no roteiro;",
      "Guia acompanhante deste o Brasil e Guias locais em Português ou espanhol durante as visitas;",
      "Seguro de viagem, Kit de Viagem Mondiale Vix, Maleteiro nos hotéis quando disponível, Taxas de hoteleiras e impostos previstos no programa."

    ],
    description: [
      "Não está incluso no pacote: Gorjetas, Entradas não mencionadas no roteiro, Refeições não mencionadas no roteiro ",
      "Opcionais de passeio são pagos a parte",
     
    ],
    policy: [
"Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros (passando maquininha empresa)",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
    ],
    image: JapaoeCoreia,
    imageH: JapaoeCoreiaH,
    lamina: JapaoeCoreiaL,
    pdf: JapaoeCoreiaPdf,
    dayByDay: [],
  },

  {
    type: SlideType.internacional,
    title: "O melhor da Colombia",
    period: "8 noites",
    initialDate: "17/08/2026",
    finalDate: "19/08/2026",
    parcelValue: 175.0,
    qtdParcel: 10,
    entry: 764.0,
    value: 2514.0,
    include: [
      "Passagem aerea ida e volta com franquia de bagagem de 10kg e 23kg;",
      "02 noites de hospedagem em Bogotá com café da manhã no Hotel Cosmos 100 - Hotel y centro de convenciones ou Similar;",
      "03 noites de hospedagem em San Andrés no Hotel El Dorado no regime ALL INCLUSIVE ou Similar;",
      "03 noites de hospedagem em Cartagena com café da manhã no Hotel Casa Índia Catalian ou Similar;",
      "Traslado de chegada e saída nas 3 cidades",
      "Taxas de embarque",
      "Seguro de viagem.",
    ],
    description: [
      "Não está incluso no pacote: Gorjetas, Entradas não mencionadas no roteiro, Refeições não mencionadas no roteiro ",
     
    ],
    policy: [
      "FORMA DE PAGAMENTO:",
      "Entrada de 25% (pix) + Parcelamento Via Link em até 10 vezes s/juros(link) / Parcelamento Via Cartão de crédito em até 12 vezes maquineta loja ou A Vista: 03% de desconto sobre Tarifa",
      "",
      "CONDIÇÕES GERAIS:",
      "• Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros; e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "• Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "• Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo – sem reembolso e não tem marcação de assentos);",
      "• Consulte-nos valores e disponibilidade de outros hotéis de acordo com a necessidade do cliente.",
      "",
      "DOCUMENTOS PARA VIAGEM:",
      "Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado ou CNH ORIGINAL;",
      "Para crianças é aceito a certidão de nascimento ORIGINAL, quando viajando com um dos pais. * Menores de idade a partir de 12 anos deverão apresentar o RG; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro."
    ],
    image: Colombia,
    imageH: ColombiaH,
    lamina: ColombiaL,
    pdf: ColombiaPdf,
    dayByDay: [],
  },

    {
    type: SlideType.internacional,
    title: "O melhor dos Lagos Andinos",
    period: "12 noites",
    initialDate: "20/08/2026",
    finalDate: "09/09/2026",
    parcelValue: 212.0,
    qtdParcel: 10,
    entry: 912.0,
    value: 2999.0,
    include: [
      "Passagem Aérea ida e volta voando Latam com franquia de Bagagem de 10Kg e 23Kg;",
      "Transfer in/out entre os aeroportos;",
      "City tour com guia local durante todo o roteiro;",
      "03 Noites de Hospedagem em Santiago com café da manhã;",
      "02 Noites de Hospedagem em Puerto Varas com café da manhã;",
      "01 Noites de Hospedagem em Peulla com café da manhã;",
      "04 Noites de Hospedagem em Bariloche com café da manhã;",
      "02 Noites de Hospedagem em Buenos Aires com café da manhã;",
      "Seguro de viagem.",
    ],
    description: [
      "Não está incluso no pacote: Gorjetas, Entradas não mencionadas no roteiro, Refeições não mencionadas no roteiro ",
    ],
    policy: [
      "FORMA DE PAGAMENTO:",
      "Entrada de 25% (pix) + Parcelamento Via Link em até 10 vezes s/juros(link) / Parcelamento Via Cartão de crédito em até 12 vezes maquineta loja ou A Vista: 03% de desconto sobre Tarifa",
      "",
      "CONDIÇÕES GERAIS:",
      "• Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros; e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "• Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "• Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo – sem reembolso e não tem marcação de assentos);",
      "• Consulte-nos valores e disponibilidade de outros hotéis de acordo com a necessidade do cliente.",
      "",
      "DOCUMENTOS PARA VIAGEM:",
      "Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado ou CNH ORIGINAL;",
      "Para crianças é aceito a certidão de nascimento ORIGINAL, quando viajando com um dos pais. * Menores de idade a partir de 12 anos deverão apresentar o RG; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro."
    ],
    image: LagosAndinos,
    imageH: LagosAndinosH,
    lamina: LagosAndinosL,
    pdf: LagosAndinosPdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Fazzenda Park Resort All Inclusive (SC) - Julho",
    period: "04 noites",
    initialDate: "17/07/2025",
    finalDate: "21/07/2025",
    parcelValue: 540.0,
    qtdParcel: 12,
    entry: 0.0,
    value: 6390.0,
    include: [
      "Passagem aérea Vitoria x Navegantes x Vitoria com a Latam com direito a 01 mala despachada de ate 23 kg;",
      "04 Noites de Hospedagem no Fazzenda Park Resort com sistema All Inclusive -https://www.fazzenda.com.br;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "Seguro viagem."      
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
      "Valor da taxa de embarque R$ 96,00 por pessoa deverá ser adicionado acima.",
    ],
    policy: [
      "Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
    ],
    image: FazzendaJulho,
    imageH: FazzendaJulhoH,
    lamina: FazzendaJulhoL,
    pdf: FazzendaJulhoPdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Foz do Iguaçu (PR) - Compras de Natal",
    period: "04 noites",
    initialDate: "03/12/2026",
    finalDate: "07/12/2026",
    parcelValue: 208.0,
    qtdParcel: 12,
    entry: 795.00,
    value: 3195.50,
    include: [
      "Passagem aerea ida e volta com franquia de bagagem de 10Kg e 23Kg;",
      "04 Noties de hospedagem com café da manhã;",
      "Transfer in/out - Aeroporto x hotel x Aeroporto;",
      "Ida ao Paraguai para compras (05 Horas de duração);",
      "Seguro viagem."
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "FORMA DE PAGAMENTO:",
      "Entrada de 25% (pix) + Parcelamento Via Link em até 10 vezes s/juros(link) / Parcelamento Via Cartão de crédito em até 12 vezes maquineta loja ou A Vista: 03% de desconto sobre Tarifa",
      "",
      "CONDIÇÕES GERAIS:",
      "• Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros; e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "• Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "• Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo – sem reembolso e não tem marcação de assentos);",
      "• Consulte-nos valores e disponibilidade de outros hotéis de acordo com a necessidade do cliente.",
      "",
      "DOCUMENTOS PARA VIAGEM:",
      "Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado ou CNH ORIGINAL;",
      "Para crianças é aceito a certidão de nascimento ORIGINAL, quando viajando com um dos pais. * Menores de idade a partir de 12 anos deverão apresentar o RG; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro."
    ],
    image: FozCompras,
    imageH: FozComprasH,
    lamina: FozComprasL,
    pdf: FozComprasPdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Rota das emoções - Segundo Semestre",
    period: "12 noites",
    initialDate: "23/08/2026",
    finalDate: "02/09/2026",
    parcelValue: 640,
    qtdParcel: 12,
    entry: 2500.0,
    value: 9690.0,
    include: [
      "Passagem aerea Vitoria x São Luís x Fortaleza x Vitoria com a Gol com 01mala de ate 10 Kg;",
      "Traslado aeroporto de São Luís x Hotel em São Luís - Regular;",
      "Guias locais e Acompanhante desde São Luís até Fortaleza",
      "02 Noites de Hospedagem em São Luís no Hotel Brisamar Apto Classic com café da manhã;",
      "City Tour Histórico em São Luís - Regular;",
      "Traslado Hotel São Luís x Barreirinhas - Saída as 06:30 h - Duração de 04 Horas - Regular;",
      "02 Noites de Hospedagem em Barreirinhas em Chale Standard com café da manhã;",
      "Passeio pelo Grandes Lençóis - Saída as 14:00 h - Regular;",
      "Passeio pelo Rio Preguiças passando por Vassouras, Mandacaru e caburé Saida as 08:00 h - Regular;",
      "Traslado Hotel Barreirinhas x Parnaíba - Regular;",
      "01 Noite em Parnaíba no Citi Hotel em Apto Luxo com café da manhã;",
      "Passeio pelo Delta do Parnaíba - Saida as 13:30 h - Regular;",
      "Traslado Hotel Parnaíba x Jeri - Regular;",
      "Taxa de preservação para entrada em Jericoacoara;",
      "03 Noites de Hospedagem em Jeri no Hotel Jeri Village em Apto Standard com café da manhã;",
      "02 Passeios Lado Leste & Oeste em Jericoacoara;",
      "Traslado Jeri x Hotel Fortaleza - Regular;",
      "02 Noites de Hospedagem no Hotel Beira Mar em Apto Standard com café da manhã;",
      "City Tour em Fortaleza- Panorâmico + Ida a Cumbuco - Regular;",
      "Traslado aeroporto de Fortaleza x Aeroporto - Regular;",      
      "Seguro viagem.",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "FORMA DE PAGAMENTO:",
      "Entrada de 25% (pix) + Parcelamento Via Link em até 10 vezes s/juros(link) / Parcelamento Via Cartão de crédito em até 12 vezes maquineta loja ou A Vista: 03% de desconto sobre Tarifa",
      "",
      "CONDIÇÕES GERAIS:",
      "• Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros; e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "• Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "• Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo – sem reembolso e não tem marcação de assentos);",
      "• Consulte-nos valores e disponibilidade de outros hotéis de acordo com a necessidade do cliente.",
      "",
      "DOCUMENTOS PARA VIAGEM:",
      "Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado ou CNH ORIGINAL;",
      "Para crianças é aceito a certidão de nascimento ORIGINAL, quando viajando com um dos pais. * Menores de idade a partir de 12 anos deverão apresentar o RG; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro."
    ],
    image: RotaEmocoes,
    imageH: RotaEmocoesH,
    lamina: RotaEmocoesL,
    pdf: RotaEmocoesPdf,
    dayByDay: [],
  },

    {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Rota das emoções - 01º Semestre",
    period: "10 noites",
    initialDate: "31/05/2026",
    finalDate: "10/06/2026",
    parcelValue: 545,
    qtdParcel: 12,
    entry: 1990.0,
    value: 8277.0,
    include: [
      "Passagem aérea Vitoria x São Luís x Fortaleza x Vitoria com a Latam com 01 mala de até 10 kg;",
      "Traslado aeroporto de São Luís x Hotel em São Luís- Regular;",
      "02 Noite de Hospedagem em São Luís no Hotel Resort Rio Poty em apto Std com café;",
      "City Tour Histórico em São Luís - Regular",
      "Traslado Hotel São Luís x Barreirinhas - Saída as 06:30 h - Duração de 04 Horas - Regular;",
      "02 Noites de Hospedagem em Barreirinhas no Grand Lençóis Flat Residence em apto Lagoa com café;",
      "Passeio pelo Grandes Lençóis - Saída as 14:00 h - Regular;",
      "Passeio pelo Rio Preguiças passando por Vassouras, Mandacaru e caburé Saida as 08:00 h - Regular;",
      "Traslado Hotel Barreirinhas x Parnaíba - Regular;",
      "01 Noite em Parnaíba no Citi Hotel em apto Luxo com café;",
      "Passeio pelo Delta do Parnaíba - Saida as 13:30 h - Regular;",
      "Traslado Hotel Parnaíba x Jeri - Regular;",
      "03 Noites de Hospedagem no Hotel Jeri em Suíte com Varanda Térreo com café;",
      "Traslado Jeri x Hotel Fortaleza - Regular;",
      "02 Noites de Hospedagem no Hotel Beira Mar em apto Std com café;",
      "City Tour em Fortaleza- Panorâmico + Ida a Cumbuco - Regular;",
      "Traslado aeroporto de Fortaleza x Aeroporto - Regular;",
      "Seguro viagem.",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "FORMA DE PAGAMENTO:",
      "Entrada de 25% (pix) + Parcelamento Via Link em até 10 vezes s/juros(link) / Parcelamento Via Cartão de crédito em até 12 vezes maquineta loja ou A Vista: 03% de desconto sobre Tarifa",
      "",
      "CONDIÇÕES GERAIS:",
      "• Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros; e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "• Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "• Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo – sem reembolso e não tem marcação de assentos);",
      "• Consulte-nos valores e disponibilidade de outros hotéis de acordo com a necessidade do cliente.",
      "",
      "DOCUMENTOS PARA VIAGEM:",
      "Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado ou CNH ORIGINAL;",
      "Para crianças é aceito a certidão de nascimento ORIGINAL, quando viajando com um dos pais. * Menores de idade a partir de 12 anos deverão apresentar o RG; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro."
    ],
    image: RotaEmocoes2,
    imageH: RotaEmocoes2H,
    lamina: RotaEmocoes2L,
    pdf: RotaEmocoes2Pdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Aracaju com Canions de São Francisco",
    period: "05 noites",
    initialDate: "05/09/2025",
    finalDate: "10/09/2025",
    parcelValue: 244.0,
    qtdParcel: 12,
    entry: 945.0,
    value: 3771.0,
    include: [
      "Passagem aérea Vitoria x Aracaju x Vitoria com a Latam com direito a 01 mala de ate 10 kg;",
      "02 Noites de Hospedagem em Aracaju conforme escolha com café;",
      "Traslado aeroporto de Aracaju x Hotel - Regular;",
      "City tour em Aracaju com Praia Horário de saída do Hotel em Aracaju: às 09:00h Horário de retorno ao Hotel em Aracaju: às 16:00h - Regular;",
      "Traslado Hotel Aracaju a partir das 06:30 h com destino para os Cânions do Xingó e Passeio nesse mesmo dia com ingresso na embarcação incluso, após passeio Traslado para Hospedagem no Xingo Parque Hotel com chegada prevista as 16:00 h - Regular;",
      "02 Noites de Hospedagem no Xingo Parque Hotel em apto Luxo com Meia Pensão;",
      "Traslado Xingo Parque Hotel para passeio a Rota do Cangaço ( com ingresso na embarcação incluso ) Horário de saída do Hotel de Xingó: às 08:00h e Horário de retorno ao Hotel do Xingó: às 16:00h - Regular;",
      "Traslado Hotel Xingo x para Hotel em Aracaju Horário de saída do Hotel na região do Xingó: às 16:00h Horário de chegada no Hotel em Aracaju: às 20:00h - Regular;",
      "01 Noite de Hospedagem em Aracaju conforme escolha com café;",
      "Traslado Hotel em Aracaju x aeroporto de Aracaju - Regular."
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
      "Valor da taxa de embarque R$ 102,00 por pessoa deverá ser adicionado acima.",
    ],
    policy: [
      "•	Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral; ",
      "•	Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "•	Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte válido. Para crianças (0 a 11 anos) é aceito a certidão de nascimento  ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido ou passaporte válido; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. A ausência de documentos no embarque o passageiro não embarca causando No-show, sem possibilidade de reembolso ou crédito do valor pago. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
      "FORMAS DE PAGAMENTO:",
      "- Entrada + taxa de embarque (Pix, Transferência ou depósito) + saldo em até 9 vezes (link) ou 12 vezes (máquina) no Cartão sem juros;",
      "- Pagamento à vista 3% desconto;",
    ],
    image: Aracaju,
    imageH: AracajuH,
    lamina: AracajuL,
    pdf: AracajuPdf,
    dayByDay: [],
  },

  {
    type: SlideType.internacional,
    isBloqueio: false,
    title: "O melhor da Turquia para Brasileiros",
    period: "09 noites",
    initialDate: "03/11/2026",
    finalDate: "13/11/2026",
    parcelValue: 199.0,
    qtdParcel: 9,
    entry: 990.0,
    value: 2890.0,
    include: [
      "Passagem Aerea ida e volta desde Vitoria com Franquia de bagagem de 10Kg e 23kg;",
      "Transporte com assistente",
      "Hospedagens com café da manhã conforme roteiro abaixo",
      "05 Jantares nos Hoteis conforme roteiro",
      "Guia acompanhante falando Portugues durante todo o tour conforme roteiro abaixo",
      "Todas as entradas especificadas do itinerário",
      "City tour com guia local falando Portugues conforme roteiro",
      "Seguro de Viagem."
    ],
    description: [
      "O que não está incluso, taxas aéreas, portuárias, ingressos etc;",
      "Despesas Pessoais;",
      "Excursões Opcionais;",
      "Traslados não indicados ou em dias diferentes dos de chegada ou partida do programa;",
      "Todas as gorjetas durante a viagem;",
      "Qualquer serviço não listado como incluído.",
    ],
    policy: [
      "FORMA DE PAGAMENTO:",
      "Entrada de 30% (pix) + Parcelamento Via Link em até 10 vezes s/juros(link) / Parcelamento Via Cartão de crédito em até 12 vezes maquineta loja ou A Vista: 03% de desconto sobre Tarifa",
      "",
      "CONDIÇÕES GERAIS:",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros; e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo – sem reembolso e não tem marcação de assentos);",
      "Consulte-nos valores e disponibilidade de outros hotéis de acordo com a necessidade do cliente.",


      "DOCUMENTOS PARA VIAGEM:",
      "Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado ou CNH ORIGINAL;",
      "Para crianças é aceito a certidão de nascimento ORIGINAL, quando viajando com um dos pais. * Menores de idade a partir de 12 anos deverão apresentar o RG;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
    ],
    image: Turquia,
    imageH: TurquiaH,
    lamina: TurquiaL,
    pdf: TurquiaPdf,
    dayByDay: [],
  },

    {
    type: SlideType.internacional,
    isBloqueio: false,
    title: "Turquia, Grécia & Dubai",
    period: "16 noites",
    initialDate: "20/09/2026",
    finalDate: "07/10/2026",
    parcelValue: 324.90,
    qtdParcel: 9,
    entry: 1090.0,
    value: 4239.0,
    include: [
      "TURQUIA:",
      "Voos internacionais: VIX - IST - DXB - VIX;",
      "Hotéis Platinum 4 e/ou 5 estrelas",
      "Guia de língua portuguesa (ou bilíngue - espanhol) // Traslados com assistência em inglês",
      "Entradas e visitas a monumentos conforme mencionado no programa.",
      "Visitas de compras conforme mencionado no programa.",
      "Todos os traslados em veículos com ar-condicionado.",
      "Refeições: Café da manhã diário, 4 jantares.",
      "Traslado de Izmir/Kusadasi ao porto para embarque.",
      "",
      "DUBAI:",
      "Traslados de ida e volta para o aeroporto em carros com ar-condicionado e assistência em inglês.",
      "5 noites de hospedagem na categoria de hotel selecionada, com café da manhã.",
      "Passeio turístico de meio dia em Dubai com guia de língua portuguesa (ou bilíngue - espanhol) / Traslados com assistência em inglês",
      "Entradas nos pontos turísticos visitados.",
      "Flores e chocolates na chegada ao aeroporto.",
      "Telefone com linha local ativa para receber chamadas de qualquer lugar do mundo.",
      "Uma lembrança da sua visita aos Emirados Árabes Unidos.",
      "",
      "DURANTE O CRUZEIRO:",
      "Acomodação em cabines internas (categorias 2 e 3)",
      "Pensão completa (café da manhã, almoço, jantar)",
      "Uma taça de refrigerante, vinho ou cerveja com as refeições, almoço e jantar.",
      "Lanche da tarde, lanche da meia-noite",
      "Entretenimento e atividades a bordo",

    ],
    description: [
      "O que não está incluso, taxas aéreas, portuárias, ingressos etc",
      "Despesas Pessoais",
      "Excursões Opcionais.",
      "Traslados não indicados ou em dias diferentes dos de chegada ou partida do programa.",
      "Bebidas com refeições incluídas e durante a viagem.",
      "Todas as gorjetas durante a viagem.",
      "Qualquer serviço não listado como incluído",
      "Taxa de serviço local: Turquia - U$D 55, Dubai - U$D 35",
      "Taxas de hotel + IVA (Pacote Platinum dá Türkiye): U$D 15",
      "Taxa de turismo de Dubai Dirham: U$D 05, (hotéis 4 estrelas) e U$D 06, (hotéis 5 estrelas) por noite/quarto, pagável no check-in no hotel.",
      "",
      "DURANTE O CRUZEIRO:",
      "Guia a bordo do cruzeiro",
      "Bebidas (alcoólicas e não alcoólicas)",
      "Lavanderia, salão de beleza, despesas pessoais",
      "Excursões em terra",
      "Serviço de ônibus em Mykonos: U$D 15, ida e volta (preço sujeito a alterações)",
      "Taxa de serviço do cruzeiro: U$D 06, por dia para adultos, U$D 4, por dia para crianças de 0 a 16 anos (preço sujeito a alterações)",
      "A taxa de serviço será cobrada a bordo do navio e não pode ser paga antecipadamente",

    ],
    policy: [
      "FORMA DE PAGAMENTO:",
      "Entrada de 25% (pix) + Parcelamento Via Link em até 10 vezes s/juros(link) / Parcelamento Via Cartão de crédito em até 12 vezes maquineta loja ou A Vista: 03% de desconto sobre Tarifa",
      "",
      "CONDIÇÕES GERAIS:",
      "• Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros; e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "• Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "• Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo – sem reembolso e não tem marcação de assentos);",
      "• Consulte-nos valores e disponibilidade de outros hotéis de acordo com a necessidade do cliente.",
      "",
      "DOCUMENTOS PARA VIAGEM:",
      "Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado ou CNH ORIGINAL;",
      "Para crianças é aceito a certidão de nascimento ORIGINAL, quando viajando com um dos pais. * Menores de idade a partir de 12 anos deverão apresentar o RG; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro."
    ],
    image: TurquiaDubai,
    imageH: TurquiaDubaiH,
    lamina: TurquiaDubaiL,
    pdf: TurquiaDubaiPdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Aracaju (SE) - Feriado 07 de Setembro",
    period: "05 noites",
    initialDate: "05/09/2025",
    finalDate: "10/09/2025",
    parcelValue: 164.0,
    qtdParcel: 12,
    entry: 622.50,
    value: 2488.50,
    include: [
      "Passagem aérea Vitoria x Aracaju x Vitoria com a Latam com direito a 01 mala de ate 10 kg;",
      "05 Noites de Hospedagem conforme escolha com café;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "City Tour em Aracaju;",
      "Seguro Viagem"
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
      "Valor da taxa de embarque R$ 102,00 por pessoa deverá ser adicionado acima.",
    ],
    policy: [
      "•	Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral; ",
      "•	Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "•	Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte válido. Para crianças (0 a 11 anos) é aceito a certidão de nascimento  ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido ou passaporte válido; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. A ausência de documentos no embarque o passageiro não embarca causando No-show, sem possibilidade de reembolso ou crédito do valor pago. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
      "FORMAS DE PAGAMENTO:",
      "- Entrada + taxa de embarque (Pix, Transferência ou depósito) + saldo em até 9 vezes (link) ou 12 vezes (máquina) no Cartão sem juros;",
      "- Pagamento à vista 3% desconto;",
    ],
    image: AracajuSep,
    imageH: AracajuSepH,
    lamina: AracajuSepL,
    pdf: AracajuSepPdf,
    dayByDay: [],
  },

    {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Belo Horizonte, Ouro Preto e Mariana",
    period: "04 noites",
    initialDate: "09/04/2026",
    finalDate: "13/03/2026",
    parcelValue: 214.0,
    qtdParcel: 12,
    entry: 0.50,
    value: 2493.00,
    include: [
      "Passagem aérea Vitoria x Belo Horizonte x Vitoria com a Gol com 01 mala de ate 10 kg a Bordo;",
      "04 Noites de Hospedagem conforme escolha com café;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "City Tour em Belo Horizonte - Regular;",
      "Tour Ouro Preto e Mariana - Regular",
      "Seguro Viagem"
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "FORMA DE PAGAMENTO:",
      "Entrada de 25% (pix) + Parcelamento Via Link em até 10 vezes s/juros(link) / Parcelamento Via Cartão de crédito em até 12 vezes maquineta loja ou A Vista: 03% de desconto sobre Tarifa",
      "",
      "CONDIÇÕES GERAIS:",
      "• Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros; e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "• Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "• Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo – sem reembolso e não tem marcação de assentos);",
      "• Consulte-nos valores e disponibilidade de outros hotéis de acordo com a necessidade do cliente.",
      "",
      "DOCUMENTOS PARA VIAGEM:",
      "Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado ou CNH ORIGINAL;",
      "Para crianças é aceito a certidão de nascimento ORIGINAL, quando viajando com um dos pais. * Menores de idade a partir de 12 anos deverão apresentar o RG; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro."
    ],
    image: BeloHorizonte,
    imageH: BeloHorizonteH,
    lamina: BeloHorizonteL,
    pdf: BeloHorizontePdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Alter do Chão & Santarem (PA)",
    period: "05 noites",
    initialDate: "24/09/2025",
    finalDate: "28/09/2025",
    parcelValue: 506.0,
    qtdParcel: 12,
    entry: 1998.00,
    value: 7980.00,
    include: [
      "Passagem Aérea Vitoria x Santarém x Vitoria com a Azul com Bagagem de até 10 kg de mão;",
      "Traslados aeroporto/hotel/aeroporto;",
      "Transporte em veículos climatizados;",
      "Guia local;",
      "Passeios fluviais em lanchas rápidas ou barcos regionais",
      "Passeios conforme descritos no programa",
      "Piracaia*",
      "01 almoço, Casa do Saulo (sem bebidas alcóolicas)",
      "City-tour em Santarém com tour fluvial e Casa do Saulo",
      "03 noites de hospedagem em Alter do Chão n Hotel Terra Nativa em Suíte com café da manhã - https://hotelterranativa.com",
      "01 noite de hospedagem em Santarém no Hotel London em apto Std com café da manhãhttps://www.hotellondonsantarem.com.br",
      "Seguro Viagem",
      "Obs.: *Piracaia: Em noites de lua cheia, os índios Borari, reuniam-se a beira da praia para comer e dançarem e ouvirem histórias contadas pelos índios mais velhos. Cardápio: Peixe assado na brasa; Acompanhamentos: banana da terra, batata doce."
    ],
    description: [
      "Não inclui:",
      "Refeições, exceto as mencionadas no programa;",
      "Despesas com frigobar, telefone, internet, lavanderia e etc.;",
      "Passeios opcionais;",
      "Tudo o que não estiver expressamente mencionado no item 'inclui'",
      "Valor da taxa de embarque R$ 97,00 por pessoa deverá ser adicionado acima.",
    ],
    policy: [
      "•	Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral; ",
      "•	Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "•	Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte válido. Para crianças (0 a 11 anos) é aceito a certidão de nascimento  ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido ou passaporte válido; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. A ausência de documentos no embarque o passageiro não embarca causando No-show, sem possibilidade de reembolso ou crédito do valor pago. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
      "FORMAS DE PAGAMENTO:",
      "- Entrada + taxa de embarque (Pix, Transferência ou depósito) + saldo em até 9 vezes (link) ou 12 vezes (máquina) no Cartão sem juros;",
      "- Pagamento à vista 3% desconto;",
    ],
    image: Santarem,
    imageH: SantaremH,
    lamina: SantaremL,
    pdf: SantaremPdf,
    dayByDay: [
      {
        day: "1º dia, 24/09 – SANTARÉM / ALTER DO CHÃO",
        description: [
          "Recepção por nossa equipe de terra. Traslado ao hotel Tarde livre. À noite, participaremos de uma bela festa de confraternização e boas-vindas (Piracaia), à esta região como faziam os antigos habitantes deste local, os índios Borari, que nas noites de lua cheia iam à beira do rio para dançar, comer e beber sob a luz do luar. Vamos fazer uma imersão cultural, aboreando um belo peixe assado na brasa.",
        ],
      },
      {
        day: "2º dia, 25/09 - ALTER DO CHÃO – Lago Verde / Igapó do Macaco / Floresta Encantada",
        description: [
          "Saída Palmas: Nossos guias começam a buscar os pax nos hotéis partir das 6:30 horas, em seguida faremos um breve encontro, o breffing, será uma explanação de toda expedição para em seguida partir pra conhecer um dos lugares mais lindos do mundo. Pedra Furada: Um lugar de tirar o fôlego! Nossa primeira parada trata-se de uma formação rochosa composta de arenitos de cores variadas, esculpido pelo vários fatores da natureza, como o vento a chuva, que ao longo de milhares de anos tem sido moldada como se fosse pela mão divina, também é um criatório natural de várias espécies de pássaros como Maritacas, Araras Azuis e não para por aí, além de cenário de novela global e comerciais televisivos, cada dia vira palco de muita concorrência nos finais de tarde, por empresas que deixam a visitação para esse período, portanto optamos sempre por fazer a visitação ainda pela manhã, valorizando assim cada minuto para imagens inesquecíveis. Mirante da Pedra Furada: Os carros param bem pertinho da pedra, serão apenas 5 minutos de trilha pelo mato em areia fofa. E tem mais, uma grande passagem na rocha que parece um portal darão às boas vindas antes de subir na plataforma para ver um horizonte hipnotizante, uma das maiores riquezas naturais do Jalapão! Almoço na Dona Minervina em Pindorama: Uma Família que mora em um vale longe da Cidade, Dona Minervina e Seu Denizon criaram 11 filhos na Roça e a realidade deles mudou a partir da chagada do Turismo na Região, por conta da Lagoa do Japonês, que será a nossa próxima parada após um almoço delicioso! Lagoa do Japonês Com águas cristalinas ora verde esmeralda outro momento azul turquesa de tirar o fôlego, são um convite para um banho refrescante, a gruta imperdível abriga uma caverna com belezas extraordinárias. A lagoa tem esse nome devido à descendência oriental de um antigo dono. Por conta das rochas pontiagudas no fundo, é aconselhável o uso de calçados próprios para banho (tipo papete), assim evita o risco de machucar os pés. Ótimo lugar para máscara ou óculos de mergulho. Jantar: Dona Luciene em Ponte Alta Uma Sra. Que transformou sua casa em restaurante e hoje faz a diferença na culinária com um jantar bem diversificado, saboroso sempre com um sorriso cativante. Fica sempre em aberto esse momento dependendo do horário de chegada na cidade, já faremos o jantar e em seguida pousada Check-in nas Pousadas parceiras Todas as ousada são nossas parceiras de longa data, equipadas com Ar condicionado, TV, Camas onfortáveis e internet. Cafés da manhã servidos na própria pousada.",        
        ],
      },

      {
        day: "3º dia, 26/09 - ALTER DO CHÃO – Ponta de Pedras / Ponta do Jarí / Ponta do Cururu",
        description: [
          "Café na pousada Após o café sairemos para o segundo dia de experiências mágicas, seguiremos os próximos dias por uma estrada onde predomina o OFF ROAD TOTAL, 13 km saindo de Ponte Alta já chegaremos no primeiro atrativo. Cânion Sussuapara Esse lugar é paradinha estratégica para quem está entrando para o Jalapão, sempre causa uma grande surpresa essa visita, pela característica singular com água pingando e correndo na grande fenda entre as várias camadas de rochas que foram aberta ao longo de anos, sua trilha é de 150m por dentro do Cânion até chegarmos ao seu ápice, uma pequena cachoeira dentro da rocha, onde todos podem se refrescar, mesmo depois de ter passado por paredões de até 20 m de altura, brotando águas por lugares quem nem dar pra acreditar, a vegetação e raízes que saem como milagre no meio dos diferentes tipos de rochas que a água abriu com toda sua paciência cerrado a baixo. Voltaremos ao OFF ROAD, agora sim RAIZ... Chegaremos no nosso Almoço típico na Comunidade quilombola (Rio Novo) Dona Cleuza, teremos a oportunidade de degustar a nossa culinária inesquecível, Galinha Caipira, Pirão, farão parte dessas experiências, em locais bem rústicos, sempre buscamos fugir do fluxo de restaurantes indo em lugares mais familiares. Após almoço Praia do Pixico A beira do grande Rio Novo, lugar paradisíaco, um banho especial numa praia de rio. Em seguida faremos mais uma parada para belas fotos e pedidos na...Árvore dos desejos 5 kms a frente estará uma das experiencias mais fantásticas da expedição!!! Dunas Paisagem Única, uma serra no coração do Jalapão, onde sua composição em arenito de cores diversas foi e está sendo esculpido pelo vento e pela chuva por anos e anos até chegar as formações inusitadas, que ficam lindas nas fotos e até parece que foram moldadas a mão, como se não bastasse tanta beleza da serra, todo seu entorno, cada metro revela uma beleza diferente, lagoas, veredas, pássaros, estradas de areia dourada forma um dos mais lindos cartões postais de nossas expedições, 360 graus de pura beleza formam as DUNAS DO JALAPÃO. E, dá para acreditar que essa região do cerrado brasileiro já foi mar? Sim, de acordo com estudos realizados por pesquisadores esse território era ocupado por águas marinhas e, devido as mudanças atmosféricas e climáticas, o mar foi se afastando e deixando espaço para o atual cenário. Os mais antigos contam que o lugar por conta dos ventos fortes era chamado de VENTÂNIA e por conta de uma missa celebrada no alto das dunas em louvor ao DIVINO passaram a chamar o local de SERRA DO ESPÍRITO SANTO. Seguiremos por mais 28km e chegaremos em Mateiros indo direto pro nosso jantar e em seguida: Check-in pousada dos Buritís. Com uma área de lazer, piscina e barzinho para um banho relaxante e um bom descanso por hoje.",
        ],
      },

      {
        day: "4º dia, 27/09 - ALTER DO CHÃO / SANTARÉM –Tour Fluvial Encontro das Águas Casa do Saulo",
        description: [
          "Café da manhã no hotel. Em seguida, saída para visita a cidade de Santarém, conhecendo seus principais atrativos: Centro Histórico, Mercado Municipal, Mercado do Peixes (Tablado), Catedral, Museu João Fona. Praça do Mirante da cidade; continuando nosso passeio, seguimos em direção ao terminal fluvial para nosso tour pelos rios Tapajós e Amazonas. Neste passeio, conheceremos comunidades que vivem em palafitas nas áreas de várzeas, também teremos a oportunidade de observa botos e o fenômeno do encontra das águas barrentas do rio Amazonas com as águas verdeesmeralda do rio Tapajós. Fim de nosso passeio, retornamos ao terminal fluvial e embarcaremos em nosso veículo com destino ao Restaurante Casa do Saulo. Restaurante por duas vezes eleito como o melhor da região norte. Localizado em uma região com belo cenário natural; a floresta amazônica e o rio Tapajós. Aproveite a estrutura deste local para descansar e comtemplar a natureza. Caso queira, há a sua disposição uma bela praia. Tempo livre para almoço (não incluso). Logo após o almoço, faremos o check-in no hotel, em Santarém. Tarde e noite livres para atividades pessoais.", 
               ],
      },

      {
        day: "5º dia, 28/09 – SANTARÉM",
        description: [
          "Manhã livre até às 12h00. Traslado ao aeroporto para embarque com destino a Vitoria.",         ],
      },

    ],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Gramado (RS) - Férias de Julho",
    period: "04 noites",
    initialDate: "17/07/2026",
    finalDate: "21/07/2026",
    parcelValue: 162.50,
    qtdParcel: 12,
    entry: 612.0,
    value: 2488.0,
    include: [
      "Passagem Aérea Vitoria x Porto Alegre x Vitoria com a Gol com direito a 01 mala de até 10 kg;",
      "04 Noites conforme escolha com café;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "City Tour Gramado e Canela -Regular - Não Inclui Ingressos nas entradas dos Parques;",
      "Seguro viagem",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
      "Valor da taxa de embarque R$ 102,00 por pessoa deverá ser adicionado acima.",
    ],
    policy: [
      "FORMA DE PAGAMENTO:",
      "Entrada de 25% (pix) + Parcelamento Via Link em até 10 vezes s/juros(link) / Parcelamento Via Cartão de crédito em até 12 vezes maquineta loja ou A Vista: 03% de desconto sobre Tarifa",
      "",
      "CONDIÇÕES GERAIS:",
      "• Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros; e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "• Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "• Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo – sem reembolso e não tem marcação de assentos);",
      "• Consulte-nos valores e disponibilidade de outros hotéis de acordo com a necessidade do cliente.",
      "",
      "DOCUMENTOS PARA VIAGEM:",
      "Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado ou CNH ORIGINAL;",
      "Para crianças é aceito a certidão de nascimento ORIGINAL, quando viajando com um dos pais. * Menores de idade a partir de 12 anos deverão apresentar o RG; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro."
    ],
    image: GramadoJulho2026,
    imageH: GramadoJulho2026H,
    lamina: GramadoJulho2026L,
    pdf: GramadoJulho2026Pdf,
    dayByDay: [],
  },

  {
    type: SlideType.navio,
    title: "MSC Cruzeiro pelo nordeste - Férias de janeiro",
    period: "07 noites",
    initialDate: "17/01/2026",
    finalDate: "24/01/2026",
    parcelValue: 388.50,
    qtdParcel: 12,
    entry: 790.0,
    value: 5446.0,
    include: [
      "07 noites a Bordo do Navio MSC Armonia com todas as alimentações Inclusas",
      "Seguro de viagem",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
      "",
      "Roteiro:",
      "Rio de janeiro x Maceió x Salvador x Ilhéus x Rio de Janeiro",
      "",
      "VALOR POR PESSOA EM R$, A PARTIR DE:",
      "CABINE INTERNA",
      "Dupla - Entrada - R$ 790,00 + 12 x de R$ 388,50 s/juros no cartão",
      "Tripla - Entrada - R$ 730,00 + 12 x de R$ 344,25 s/juros no cartão",
      "",
      "CABINE EXTERNA COM VISTA PARA O MAR",
      "Dupla - Entrada - R$ 930,00 + 12 x de R$ 417,00 s/juros no cartão",
      "Tripla - Entrada - R$ 890,00 + 12 x de R$ 393,00 s/juros no cartão",
      "",
      "CABINE COM VARANDA",
      "Dupla - Entrada - R$ 1.140,00 + 12 x de R$ 571,50 s/juros no cartão",
      "Tripla - Entrada - R$ 1.050,00 + 12 x de R$ 513,75 s/juros no cartão",
    ],
    policy: [
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea.",
    ],
    image: MSCJan,
    imageH: MSCJanH,
    lamina: MSCJanL,
    pdf: MSCJanPdf,
    isNavio: true,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "João Pessoa (PB) - Feriado de N. S. da Penha",
    period: "04 noites",
    initialDate: "09/04/2026",
    finalDate: "13/04/2026",
    parcelValue: 198.0,
    qtdParcel: 12,
    entry: 762.0,
    value: 3046.0,
    include: [
      "Passagem aérea Vitoria x João Pessoa x Vitoria com a Latam com direito a 01 mala de 10 kg a bordo;",
      "04 Noites de Hospedagem conforme escolha com café;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "Entardecer na Praia Fluvial do Jacaré ( A Tarde ) - Regular;",
      "Seguro viagem"
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
      "Valor da taxa de embarque R$ 98,00 por pessoa deverá ser adicionado acima.",
    ],
    policy: [
      "FORMA DE PAGAMENTO:",
      "Entrada de 25% (pix) + Parcelamento Via Link em até 10 vezes s/juros(link) / Parcelamento Via Cartão de crédito em até 12 vezes maquineta loja ou A Vista: 03% de desconto sobre Tarifa",
      "",
      "CONDIÇÕES GERAIS:",
      "• Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros; e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "• Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "• Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo – sem reembolso e não tem marcação de assentos);",
      "• Consulte-nos valores e disponibilidade de outros hotéis de acordo com a necessidade do cliente.",
      "",
      "DOCUMENTOS PARA VIAGEM:",
      "Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado ou CNH ORIGINAL;",
      "Para crianças é aceito a certidão de nascimento ORIGINAL, quando viajando com um dos pais. * Menores de idade a partir de 12 anos deverão apresentar o RG; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro."
    ],
    image: JoaoPessoa,
    imageH: JoaoPessoaH,
    lamina: JoaoPessoaL,
    pdf: JoaoPessoaPdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Gramado (RS) - Natal luz Férias de Janeiro 2027",
    period: "04 noites",
    initialDate: "06/01/2027",
    finalDate: "10/01/2027",
    parcelValue: 206.0,
    qtdParcel: 12,
    entry: 785.0,
    value: 3162.0,
    include: [
      "Passagem Aérea Vitoria x Porto Alegre x Vitoria com direito a 01 mala de até 10 kg;",
      "04 Noites de hospedagem conforme escolha com café;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "City Tour Gramado e Canela -Regular - Não Inclui Ingressos nas entradas dos Parques;",
      "Seguro viagem",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros (passando maquininha empresa)",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
    ],
    image: GramadoFerias2027,
    imageH: GramadoFerias2027H,
    lamina: GramadoFerias2027L,
    pdf: GramadoFerias2027Pdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Foz do Iguaçu (PR) - Promocional",
    period: "04 noites",
    initialDate: "18/05/2026",
    finalDate: "22/05/2026",
    parcelValue: 198.0,
    qtdParcel: 12,
    entry: 0.0,
    value: 2307.0,
    include: [
      "Passagem aérea Vitoria x Foz x Vitoria com a Latam com direito a 01 mala de até 23 Kg;",
      "04 Noites de Hospedagem conforme escolha com café;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "Ida a Cataratas Brasileiras - Sem Ingresso - Regular;",
      "Seguro viagem."
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "•	Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral; ",
      "•	Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "•	Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte válido. Para crianças (0 a 11 anos) é aceito a certidão de nascimento  ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido ou passaporte válido; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. A ausência de documentos no embarque o passageiro não embarca causando No-show, sem possibilidade de reembolso ou crédito do valor pago. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
      "FORMAS DE PAGAMENTO:",
      "- Entrada + taxa de embarque (Pix, Transferência ou depósito) + saldo em até 9 vezes (link) ou 12 vezes (máquina) no Cartão sem juros;",
      "- Pagamento à vista 3% desconto;",
    ],
    image: FozBaixa,
    imageH: FozBaixaH,
    lamina: FozBaixaL,
    pdf: FozBaixaPdf,
    dayByDay: [],
  },


  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Beto Carrero - Promo",
    period: "4 noites",
    initialDate: "13/07/2025",
    finalDate: "17/07/2025",
    parcelValue: 150.0,
    qtdParcel: 12,
    entry: 567.0,
    value: 2267.0,
    include: [
      "Passagem aérea Vitoria x Navegantes x Vitoria com a Latam com direito a 01 mala despachada de ate 23 kg;",
      "04 Noites de Hospedagem Pousada do Pescador em apto Std com café - https://www.pousadapescador.com;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "02 Dias de Parque Beto Carrero com Ingresso;",
      "Seguro de viagem",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros (passando maquininha empresa)",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
    ],
    image: BetoCarreroPromo,
    imageH: BetoCarreroPromoH,
    lamina: BetoCarreroPromoL,
    pdf: BetoCarreroPromoPdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Foz do Iguaçu (PR) - Férias de Julho",
    period: "4 noites",
    initialDate: "19/07/2025",
    finalDate: "23/07/2025",
    parcelValue: 197.0,
    qtdParcel: 12,
    entry: 0.0,
    value: 2270.0,
    include: [
      "Passagem aérea Vitoria x Foz x Vitoria com a Latam com direito a 01 mala de até 23 Kg;",
      "04 Noites de Hospedagem conforme escolha com café;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "Ida a Cataratas Brasileiras - Sem Ingresso + Parque das Aves - Sem Ingresso - Regular;",
      "Seguro de viagem",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
      "Valor da taxa de embarque R$ 100,00 por pessoa e deverá ser adicionado acima"
    ],
    policy: [
      "Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros (passando maquininha empresa)",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
    ],
    image: FozJulho,
    imageH: FozJulhoH,
    lamina: FozJulhoL,
    pdf: FozJulhoPdf,
    dayByDay: [],
  },
  
  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Porto de Galinhas (PE) - Baixa Temporada",
    period: "04 noites",
    initialDate: "03/02/2026",
    finalDate: "07/02/2026",
    parcelValue: 134.0,
    qtdParcel: 12,
    entry: 498.0,
    value: 2040.0,
    include: [
      "Passagem Aérea Vitoria x Recife x Vitoria com a Latam com Direito a 01 mala despachada de até 23 kg;",
      "04 Noites de Hospedagem conforme escolha com café;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "Seguro viagem",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "•	Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral; ",
      "•	Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "•	Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte válido. Para crianças (0 a 11 anos) é aceito a certidão de nascimento  ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido ou passaporte válido; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. A ausência de documentos no embarque o passageiro não embarca causando No-show, sem possibilidade de reembolso ou crédito do valor pago. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
      "FORMAS DE PAGAMENTO:",
      "- Entrada + taxa de embarque (Pix, Transferência ou depósito) + saldo em até 9 vezes (link) ou 12 vezes (máquina) no Cartão sem juros;",
      "- Pagamento à vista 3% desconto;",
    ],
    image: PglPromo,
    imageH: PglPromoH,
    lamina: PglPromoL,
    pdf: PglPromoPdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Lençóis & São Luis (MA) - Feriado N. S da Penha",
    period: "04 noites",
    initialDate: "09/04/2026",
    finalDate: "13/04/2026",
    parcelValue: 270,
    qtdParcel: 12,
    entry: 890.0,
    value: 4009.10,
    include: [
      "Passagem aérea Vitoria x São Luís x Vitoria com a Latam com Bagagem de ate 10 kg;",
      "Traslado aeroporto de São Luís x Hotel em São Luís - Regular, 01 Noite em São Luís no Hotel Costa do Atlantico em apto Std com café -https://www.costaatlanticohotel.com.br - Turístico;",
      "Traslado Hotel São Luís x Barreirinhas - Saida a partir das 07:00 h da manha com duração de 04 Horas com chegada prevista as 11:30 h - Regular;",
      "02 Noites de Hospedagem em Barreirinhas na Pousada Boa Vista em Apto Master com café da manha - https://www.pousadaboavista.com.br - Turístico;",
      "Passeio aos Grandes Lençóis - Saida as 14:00 h - Regular;",
      "Passeio de Lancha Voadeira por Vassouras, Mandacaru e Caburé - Regular - Saida as 08:00 h;",
      "Traslado Barreirinhas x São Luís - Saida as 16:00 h com destino a São Luís - Duração de 04 Horas - Regular;",
      "01 Noite de Hospedagem em São Luís no Hotel Costa do Atlantico em apto Std com café - https://www.costaatlanticohotel.com.br - Turístico;",
      "Traslado Hotel São Luís x aeroporto de São Luís - Regular;",
      "Seguro viagem",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "•	Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral; ",
      "•	Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "•	Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte válido. Para crianças (0 a 11 anos) é aceito a certidão de nascimento  ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido ou passaporte válido; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. A ausência de documentos no embarque o passageiro não embarca causando No-show, sem possibilidade de reembolso ou crédito do valor pago. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
      "FORMAS DE PAGAMENTO:",
      "- Entrada + taxa de embarque (Pix, Transferência ou depósito) + saldo em até 9 vezes (link) ou 12 vezes (máquina) no Cartão sem juros;",
      "- Pagamento à vista 3% desconto;",
    ],
    image: Lencois,
    imageH: LencoisH,
    lamina: LencoisL,
    pdf: LencoisPdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Gramado (RS) - Natal Luz - Primeira Saída ",
    period: "04 noites",
    initialDate: "23/10/2026",
    finalDate: "27/10/2026",
    parcelValue: 206.0,
    qtdParcel: 12,
    entry: 785.0,
    value: 3160.0,
    include: [
      "Passagem Aérea Vitoria x Porto Alegre x Vitoria com a Latam com direito a 01 mala de até 10 kg;",
      "04 Noites de hospedagem conforme escolha com café;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "City Tour Gramado e Canela -Regular - Não Inclui Ingressos nas entradas dos Parques;",
      "Seguro viagem",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
      "Valor da taxa de embarque R$ 108,00 por pessoa e deverá ser adicionado acima"
    ],
    policy: [
      "•	Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral; ",
      "•	Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "•	Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte válido. Para crianças (0 a 11 anos) é aceito a certidão de nascimento  ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido ou passaporte válido; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. A ausência de documentos no embarque o passageiro não embarca causando No-show, sem possibilidade de reembolso ou crédito do valor pago. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
      "FORMAS DE PAGAMENTO:",
      "- Entrada + taxa de embarque (Pix, Transferência ou depósito) + saldo em até 9 vezes (link) ou 12 vezes (máquina) no Cartão sem juros;",
      "- Pagamento à vista 3% desconto;",
    ],
    image: GramadoOMelhor,
    imageH: GramadoOMelhorH,
    lamina: GramadoOMelhorL,
    pdf: GramadoOMelhorPdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Gramado (RS) - Natal Luz - Segunda Saída ",
    period: "04 noites",
    initialDate: "11/11/2026",
    finalDate: "15/11/2026",
    parcelValue: 212.0,
    qtdParcel: 12,
    entry: 814.0,
    value: 3260.0,
    include: [
      "Passagem Aérea Vitoria x Porto Alegre x Vitoria com a Gol com direito a 01 mala de até 10 kg;",
      "04 Noites de hospedagem conforme escolha com café;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "City Tour Gramado e Canela -Regular - Não Inclui Ingressos nas entradas dos Parques;",
      "Seguro viagem",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
      "Valor da taxa de embarque R$ 108,00 por pessoa e deverá ser adicionado acima"
    ],
    policy: [
      "•	Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral; ",
      "•	Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "•	Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte válido. Para crianças (0 a 11 anos) é aceito a certidão de nascimento  ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido ou passaporte válido; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. A ausência de documentos no embarque o passageiro não embarca causando No-show, sem possibilidade de reembolso ou crédito do valor pago. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
      "FORMAS DE PAGAMENTO:",
      "- Entrada + taxa de embarque (Pix, Transferência ou depósito) + saldo em até 9 vezes (link) ou 12 vezes (máquina) no Cartão sem juros;",
      "- Pagamento à vista 3% desconto;",
    ],
    image: NatalLuz02saida,
    imageH: NatalLuz02saidaH,
    lamina: NatalLuz02saidaL,
    pdf: NatalLuz02saidaPdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Porto de Galinhas (PE) - Baixa Temporada",
    period: "04 noites",
    initialDate: "19/09/2025",
    finalDate: "23/09/2025",
    parcelValue: 140.50,
    qtdParcel: 12,
    entry: 525.0,
    value: 2100.0,
    include: [
      "Passagem Aérea Vitoria x Recife x Vitoria com a Latam com direito a 01 mala despachada de ate 23 kg;",
      "04 Noites de Hospedagem conforme escolha com café;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "Seguro viagem",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
      "Valor da taxa de embarque R$ 111,00 por pessoa deverá ser adicionado acima.",
    ],
    policy: [
      "•	Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral; ",
      "•	Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "•	Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte válido. Para crianças (0 a 11 anos) é aceito a certidão de nascimento  ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido ou passaporte válido; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. A ausência de documentos no embarque o passageiro não embarca causando No-show, sem possibilidade de reembolso ou crédito do valor pago. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
      "FORMAS DE PAGAMENTO:",
      "- Entrada + taxa de embarque (Pix, Transferência ou depósito) + saldo em até 9 vezes (link) ou 12 vezes (máquina) no Cartão sem juros;",
      "- Pagamento à vista 3% desconto;",
    ],
    image: PglBaixa,
    imageH: PglBaixaH,
    lamina: PglBaixaL,
    pdf: PglBaixaPdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "O melhor de Recife com Trem do forró",
    period: "04 noites",
    initialDate: "18/06/2026",
    finalDate: "22/06/2026",
    parcelValue: 203.0,
    qtdParcel: 12,
    entry: 775.0,
    value: 3118.0,
    include: [
      "Passagem aérea Vitoria x Recife x Vitoria com a Gol com direito a 01 mala de ate 10 kg;",
      "04 Noites de Hospedagem em Recife conforme escolha com café;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "Tour Recife x Olinda - Regular",
      "raslado de Ida e Volta para o Trem do Forro com o percurso Estação Velha ate galante, ingresso + Blusa e Pulseira - Regular",
      "Seguro viagem",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "•	Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral; ",
      "•	Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "•	Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte válido. Para crianças (0 a 11 anos) é aceito a certidão de nascimento  ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido ou passaporte válido; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. A ausência de documentos no embarque o passageiro não embarca causando No-show, sem possibilidade de reembolso ou crédito do valor pago. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
      "FORMAS DE PAGAMENTO:",
      "- Entrada + taxa de embarque (Pix, Transferência ou depósito) + saldo em até 9 vezes (link) ou 12 vezes (máquina) no Cartão sem juros;",
      "- Pagamento à vista 3% desconto;",
    ],
    image: MelhorDoRecife,
    imageH: MelhorDoRecifeH,
    lamina: MelhorDoRecifeL,
    pdf: MelhorDoRecifePdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Bonito (MS) - Feriado da independência",
    period: "04 noites",
    initialDate: "04/09/2025",
    finalDate: "08/09/2025",
    parcelValue: 193.0,
    qtdParcel: 12,
    entry: 745.50,
    value: 2968.50,
    include: [
      "Passagem aérea Vitoria x Campo Grande x Vitoria com a Latam com direito a 01 mala despachada de ate 23 kg;",
      "04 Noites de Hospedagem conforme escolha com café;",
      "Traslados aeroporto Campo Grande x Bonito x aeroporto de Campo Grande- Regular;",
      "Passeio Gruta do Lago Azul - Regular",
      "Seguro viagem"      
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
      "Valor da taxa de embarque R$ 90,00 por pessoa deverá ser adicionado acima.",
      "",
      "Descrição do passeio Gruta do Lago Azul:",
      "",
      " • A Gruta do Lago Azul é um dos principais cartões-postais de Bonito-MS e certamente um dos cenários mais belos do Brasil.",
      "  Além de ter um visual incrível, a Gruta do Lago Azul encanta pela sua magnitude. Ela é uma das maiores cavidades inundadas do planeta e visitá-la é uma verdadeira viagem às origens da região",
      " • O passeio é totalmente contemplativo e para chegar até o lago, é necessário descer quase 300 degraus, o equivalente a um prédio de 12 andares. Mas não se preocupe, a recompensa vale a pena",
      " • O lago é cristalino e a cor azulada que o torna famoso se deve a uma combinação de fatores, como a localização da gruta e a presença de minerais em seu fundo. Nas primeiras horas da manhã o azul fica ainda mais intenso, e fora do horário de visitação não é mais possível ver essa coloração.",
      "",
      " Políticas: Idade mínima 06 anos completos. (Proibida a entrada para menores de 06 anos)"
    ],
    policy: [
      "Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
    ],
    image: BonitoSet,
    imageH: BonitoSetH,
    lamina: BonitoSetL,
    pdf: BonitoSetPdf,
    dayByDay: [],
  },

    {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Arrail D'Ajuda (BA) - Feriado das crianças",
    period: "05 noites",
    initialDate: "10/10/2025",
    finalDate: "15/10/2025",
    parcelValue: 208.0,
    qtdParcel: 12,
    entry: 795.50,
    value: 3180.50,
    include: [
      "Passagem Aérea Vitoria x Porto Seguro x Vitoria com a Latam com direito a 01 mala despachada de ate 23 kg;",
      "05 Noites de Hospedagem conforme escolha com café;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "Seguro viagem."
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "•	Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral; ",
      "•	Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "•	Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte válido. Para crianças (0 a 11 anos) é aceito a certidão de nascimento  ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido ou passaporte válido; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. A ausência de documentos no embarque o passageiro não embarca causando No-show, sem possibilidade de reembolso ou crédito do valor pago. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
      "FORMAS DE PAGAMENTO:",
      "- Entrada + taxa de embarque (Pix, Transferência ou depósito) + saldo em até 9 vezes (link) ou 12 vezes (máquina) no Cartão sem juros;",
      "- Pagamento à vista 3% desconto;",
    ],
    image: Arraial,
    imageH: ArraialH,
    lamina: ArraialL,
    pdf: ArraialPdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: false,
    title: "Bonito (MS) - Pacote Promocional",
    period: "04 noites",
    initialDate: "19/11/2026",
    finalDate: "23/11/2026",
    parcelValue: 181.0,
    qtdParcel: 12,
    entry: 687.00,
    value: 2776.00,
    include: [
      "Passagem aérea ida e volta com franquia de bagagem de 10Kg;",
      "04 noites de Hospedagem com café da manhã;",
      "Transfer in/out - Aeroporto x Hotel x Aeroporto;",
      "Seguro viagem"      
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
      "",
      "CONDICOES ESPECIFICAS DE CANCELAMENTO",
      "",
      "Entende-se por cancelamento a desistência da viagem e/ou do serviço contratado, bem como alteração de locais, datas e roteiros.",
      "Em casos de alterações de reservas já solicitadas, mesmo não havendo sua confirmação, haverá penalidade automática e cobrança das despesas administrativas que ocorrerem, independentemente das multas que venham a incidir, de conformidade com o item 5.3 deste contrato.",
      "Na hipótese de cancelamento e/ou alterações, fica ajustada e autorizada desde já a retenção de 20%, sobre o valor total do pacote ou do produto turístico comercializado, a  título de intermediação remunerada da cadeia de prestadores de serviço.",
      "Solicitações de cancelamento da viagem, de produtos ou serviços contratados deverão ser necessariamente feitas por escrito e as multas serão aplicadas segundo as regras que nortearam a contratação dos serviços e as sanções impostas à MONDIALE pelos demais fornecedores e/ou prestadores de serviços envolvidos. Em caso de prorrogação da viagem por motivo de força maior, os passageiros ficarão sujeito as penalidades impostas pelas Cias. Aéreas, receptivos locais e taxas hoteleiras.",
      "Nos voos de fretamento e/ou voos regulares em sistemas “block- charter” (bloqueio aéreo), o cancelamento, ou não comparecimento para embarque ou a não utilização da passagem aérea fará o passageiro perder o direito a outro embarque ou a reembolso/ crédito do bilhete, nos termos e na forma da legislação de regência.",
      "Nos voos regulares, ficam os passageiros cientes de que as passagens aéreas emitidas como tarifas especiais reduzidas, implicam em determinadas restrições (endossos, mudanças de rotas, reembolsos, etc). Assim, uma vez emitidas, serão aplicadas as penalidades e restrições previstas nas regras tarifárias e em caso de reembolso, o mesmo somente será feito após o ressarcimento por parte da Cia. Aérea. Na hipótese de abandono/desistência da viagem após a mesma ter sido iniciada ou da não utilização de qualquer serviço confirmado, não será concedido qualquer tipo de reembolso. Fica ajustado entre as partes que serão aplicadas ao presente contrato as regras previstas na Medida Provisória 948/20 e na Lei nº 14.046/20, notadamente, mas não exclusivamente, aquelas contidas no artigo 3º e seus respectivos parágrafos, facultando-se, ainda, à MONDIALE na hipótese de cancelamento de serviços/restituição de valores, a retenção de importância pecuniária decorrente do serviço que prestou, bem como eventuais descontos praticados pelos operadores dos serviços contratados."
    ],
    policy: [
      "Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",

    ],
    image: BonitoPromo,
    imageH: BonitoPromoH,
    lamina: BonitoPromoL,
    pdf: BonitoPromoPdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: false,
    title: "Gramado (RS) - Baixa Temporada",
    period: "04 noites",
    initialDate: "20/05/2026",
    finalDate: "24/05/2026",
    parcelValue: 140.0,
    qtdParcel: 12,
    entry: 0.0,
    value: 1630.0,
    include: [
      "Passagem aérea Vitoria x Porto Alegre x Vitoria com a Gol com bagagem de ate 10 kg;",
      "04 Noites de Hospedagem conforme escolha com café;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "Tour Gramado e Canela - Não inclui ingressos nas entradas dos Parques - Regular;",
      "Seguro viagem",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros (passando maquininha empresa)",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
    ],
    image: GramadoBaixa,
    imageH: GramadoBaixaH,
    lamina: GramadoBaixaL,
    pdf: GramadoBaixaPdf,
    dayByDay: [],
  },


    {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Morro de São Paulo (BA) - Férias 2027",
    period: "05 noites",
    initialDate: "13/01/2027",
    finalDate: "18/01/2027",
    parcelValue: 211.0,
    qtdParcel: 12,
    entry: 805.0,
    value: 3240.0,
    include: [
      "Passagem aérea ida e volta com franquia de bagagem de 10kg;",
      "05 Noites de hospedagem com café da manhã;",
      "Transfer - Aeroporto x Morro de SP x Aeroporto (Via Semi-Terestre);",
      "Seguro Viagem."
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "•	Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral; ",
      "•	Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "•	Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte válido. Para crianças (0 a 11 anos) é aceito a certidão de nascimento  ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido ou passaporte válido; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. A ausência de documentos no embarque o passageiro não embarca causando No-show, sem possibilidade de reembolso ou crédito do valor pago. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
      "FORMAS DE PAGAMENTO:",
      "- Entrada + taxa de embarque (Pix, Transferência ou depósito) + saldo em até 9 vezes (link) ou 12 vezes (máquina) no Cartão sem juros;",
      "- Pagamento à vista 3% desconto;",
    ],
    image: Morro2027,
    imageH: Morro2027H,
    lamina: Morro2027L,
    pdf: Morro2027Pdf,
    dayByDay: [],
  },

      {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Morro de São Paulo (BA) - Férias 2026",
    period: "07 noites",
    initialDate: "16/01/2026",
    finalDate: "23/01/2026",
    parcelValue: 156.0,
    qtdParcel: 15,
    entry: 780.0,
    value: 3030.0,
    include: [
      "Passagem aérea Vitoria x Salvador x Vitoria com a Gol com direito a 01 mala despachada de até 10 Kg;",
      "Traslado aeroporto de Salvador x Morro x aeroporto de Salvador – Via Semi -Terrestre - Regular;",
      "07 Noites de Hospedagem conforme escolha em apto STD com café;",
      "Traslado Hotel de Salvador x Aeroporto de Salvador - Regular;",
      "Seguro Viagem."
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "•	Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral; ",
      "•	Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "•	Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte válido. Para crianças (0 a 11 anos) é aceito a certidão de nascimento  ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido ou passaporte válido; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. A ausência de documentos no embarque o passageiro não embarca causando No-show, sem possibilidade de reembolso ou crédito do valor pago. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
      "FORMAS DE PAGAMENTO:",
      "- Entrada + taxa de embarque (Pix, Transferência ou depósito) + saldo em até 9 vezes (link) ou 12 vezes (máquina) no Cartão sem juros;",
      "- Pagamento à vista 3% desconto;",
    ],
    image: MorroJan,
    imageH: MorroJanH,
    lamina: MorroJanL,
    pdf: MorroJanPdf,
    dayByDay: [],
  },


  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Jericoacoara (CE) - Férias de Janeiro 2027",
    period: "05 noites",
    initialDate: "13/01/2027",
    finalDate: "18/01/2027",
    parcelValue: 252.0,
    qtdParcel: 12,
    entry: 974.0,
    value: 3881.0,
    include: [
      "Passagem aérea ida e volta - Vitoria x Jeri x Vitoria com bagagem de 10Kg;",
      "Transfer in/out - Aeroporto x Hotel x Aeroporto;",
      "05 Noites de Hospedagem com café da manhã;",
      "Seguro Viagem."
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "•	Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral; ",
      "•	Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "•	Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte válido. Para crianças (0 a 11 anos) é aceito a certidão de nascimento  ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido ou passaporte válido; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. A ausência de documentos no embarque o passageiro não embarca causando No-show, sem possibilidade de reembolso ou crédito do valor pago. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
      "FORMAS DE PAGAMENTO:",
      "- Entrada + taxa de embarque (Pix, Transferência ou depósito) + saldo em até 9 vezes (link) ou 12 vezes (máquina) no Cartão sem juros;",
      "- Pagamento à vista 3% desconto;",
    ],
    image: Jeri2027,
    imageH: Jeri2027H,
    lamina: Jeri2027L,
    pdf: Jeri2027Pdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Jalapão 2026 - Feriado de Corpus Christi",
    period: "05 noites",
    initialDate: "03/06/2026",
    finalDate: "08/06/2026",
    parcelValue: 393.0,
    qtdParcel: 12,
    entry: 1590.0,
    value: 6110.0,
    include: [
      "Passagem aérea Vitoria x Palmas x Vitoria com a Latam com bagagem de até 10 kg;",
      "Traslado aeroporto de Palmas x Hotel em Palmas - Regular;",
      "01 Noite de Hospedagem em Palmas no Vivence Suítes Palmas em apto Std com café;",
      "03 Noites de Hospedagem para Inicio do Pacote expedição ao Jalapão conforme roteiro abaixo em Pousadas Econômicas com Refeições Inclusas café, almoço e jantar durante os 03 dias sem bebidas inclusas - Regular",
      "01 Noite de Hospedagem em Palmas no Vivence Suítes Palmas em apto Std com café;",
      "Traslado Hotel Palmas x aeroporto de Palmas - Regular;",
      "Seguro Viagem."
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "•	Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral; ",
      "•	Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "•	Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte válido. Para crianças (0 a 11 anos) é aceito a certidão de nascimento  ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido ou passaporte válido; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. A ausência de documentos no embarque o passageiro não embarca causando No-show, sem possibilidade de reembolso ou crédito do valor pago. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
      "FORMAS DE PAGAMENTO:",
      "- Entrada + taxa de embarque (Pix, Transferência ou depósito) + saldo em até 9 vezes (link) ou 12 vezes (máquina) no Cartão sem juros;",
      "- Pagamento à vista 3% desconto;",
    ],
    image: Jalapao,
    imageH: JalapaoH,
    lamina: JalapaoL,
    pdf: JalapaoPdf,
    dayByDay: [],
  },

    {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Belém e Ilha de Marajó",
    period: "05 noites",
    initialDate: "13/08/2026",
    finalDate: "19/08/2026",
    parcelValue: 445.0,
    qtdParcel: 12,
    entry: 1747.0,
    value: 6980.0,
    include: [
      "Passagem aérea Vitoria x Belém x Vitoria com a Gol com direito a 01 mala de até 10 kg;",
      "03 Noites de Hospedagem em Belém no Hotel Princesa Louça em apto std com café https://www.princesabelem.com.br;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "City tour em Belém com almoço incluído - Regular;",
      "Passeio ao Combu com almoço incluído - Regular;",
      "Traslados Hotel Belém x Porto x Hotel Belém;",
      "Passagens Belém x Soure x Belém - catamara - Regular;",
      "02 Noites de Hospedagem em Soure na Pousada o Canto do Frances em apto std com café da manhã https://ocantodofrances.com;",
      "Traslados Porto de Soure x Pousada x Porto de Soure - Regular;",
      "Passeio a Fazenda São Jeronimo (Barco e Montaria de Búfalos) - Regular;",
      "City Tour em Soure - Regular;",
      "01 Noite de Hospedagem em Belém no Hotel Princesa Louça em apto std com café - https://www.princesabelem.com.br;",
      "Seguro Viagem.",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
      "Valor da taxa de embarque R$ 102,00 por pessoa deverá ser adicionado acima.",
    ],
    policy: [
      "FORMA DE PAGAMENTO:",
      "Entrada de 25% (pix) + Parcelamento Via Link em até 10 vezes s/juros(link) / Parcelamento Via Cartão de crédito em até 12 vezes maquineta loja ou A Vista: 03% de desconto sobre Tarifa",
      "",
      "CONDIÇÕES GERAIS:",
      "• Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros; e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "• Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "• Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo – sem reembolso e não tem marcação de assentos);",
      "• Consulte-nos valores e disponibilidade de outros hotéis de acordo com a necessidade do cliente.",
      "",
      "DOCUMENTOS PARA VIAGEM:",
      "Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado ou CNH ORIGINAL;",
      "Para crianças é aceito a certidão de nascimento ORIGINAL, quando viajando com um dos pais. * Menores de idade a partir de 12 anos deverão apresentar o RG; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro."
    ],
    image: BelemeMarajo,
    imageH: BelemeMarajoH,
    lamina: BelemeMarajoL,
    pdf: BelemeMarajoPdf,
    dayByDay: [],
  },

      {
    type: SlideType.internacional,
    title: "Bariloche - Abertura temporada de neve",
    period: "05 noites",
    initialDate: "01/07/2026",
    finalDate: "06/07/2026",
    parcelValue: 123.0,
    qtdParcel: 9,
    entry: 334.0,
    value: 1339.0,
    include: [
      "Passagem aérea Vitoria x Bariloche x Vitoria com a Gol com direito 01 mala de ate 23 kg despachada;",
      "04 Noites de Hospedagem em Bariloche no Hotel Cristal em apto Superior com cafe - Categoria Superior - https://hotel-cristal.com.ar;",
      "Traslados aeroporto de Bariloche x Hotel x aeroporto Bariloche - Regular;",
      "01 Noite em Guarulhos no Hotel Sleep Inn em apto Std;",
      "Seguro Viagem.",
      "",
      " Passeios Opcionais:",
      " Tour Panorâmico Circuito Chico - Sem Ingresso - Regular - Valor por pessoa - Usd 30,00",
      " Passeio de Meio Dia ao Cerro Catedral -Sem Ingresso - Regular - Valor por pessoa - Usd 36,00",
      " Excursão ao Cerro Perito Moreno -Sem Ingresso - Regular - Valor por pessoa - Usd 65,00",
      " Excursão a San Martin de Los Andes e aos Sete Lagos -Sem Ingresso - Regular - Valor por pessoa - Usd 72,00",
      " Visita a Vinícola Vinoteca Wine House - Regular - Valor por pessoa - Usd 108,00",
    ],
    description: [
      "Não está incluso no pacote: Gorjetas, Entradas não mencionadas no roteiro, Refeições não mencionadas no roteiro ",
    ],
    policy: [
      "FORMA DE PAGAMENTO:",
      "Entrada de 25% (pix) + Parcelamento Via Link em até 10 vezes s/juros(link) / Parcelamento Via Cartão de crédito em até 12 vezes maquineta loja ou A Vista: 03% de desconto sobre Tarifa",
      "",
      "CONDIÇÕES GERAIS:",
      "• Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros; e assinatura do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "• Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "• Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo – sem reembolso e não tem marcação de assentos);",
      "• Consulte-nos valores e disponibilidade de outros hotéis de acordo com a necessidade do cliente.",
      "",
      "DOCUMENTOS PARA VIAGEM:",
      "Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado ou CNH ORIGINAL;",
      "Para crianças é aceito a certidão de nascimento ORIGINAL, quando viajando com um dos pais. * Menores de idade a partir de 12 anos deverão apresentar o RG; *Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro."
    ],
    image: Bariloche,
    imageH: BarilocheH,
    lamina: BarilocheL,
    pdf: BarilochePdf,
    dayByDay: [],
  },

    {
    type: SlideType.nacional,
    isBloqueio: false,
    title: "Bonito (MS) - baixa temporada",
    period: "04 noites",
    initialDate: "22/05/2026",
    finalDate: "26/05/2026",
    parcelValue: 177.50,
    qtdParcel: 12,
    entry: 680.00,
    value: 2278.00,
    include: [
      "Passagem aérea Vitoria x Campo Grande x Vitoria com a Latam com direito a 01 mala de até 10 kg;",
      "04 Noites de Hospedagem conforme escolha com café;",
      "Traslados aeroporto Campo Grande x Bonito x aeroporto de Campo Grande- Regular;",
      "Passeio Gruta do Lago Azul com ingresso - Regular;",
      "Seguro viagem"      
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",

    ],
    image: BonitoPromo,
    imageH: BonitoPromoH,
    lamina: BonitoPromoL,
    pdf: BonitoPromoPdf,
    dayByDay: [],
  },

  {
    type: SlideType.nacional,
    isBloqueio: false,
    title: "Maceio (AL) – Feriado da Independência + Feriado de Vitória",
    period: "04 noites",
    initialDate: "04/09/2026",
    finalDate: "08/09/2026",
    parcelValue: 209.0,
    qtdParcel: 12,
    entry: 786.00,
    value: 3198.00,
    include: [
      "Passagem Aérea Vitoria x Maceió x Vitoria com a Gol com bagagem de até 10 kg;",
      "04 Noites de Hospedagem em Maceió conforme escolha com café da manhã;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "City Tour Maceió - Panorâmico + Litoral Sul com Praia do Frances - Regular;",
      "Seguro viagem"      
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",

    ],
    image: Maceio,
    imageH: MaceioH,
    lamina: MaceioL,
    pdf: MaceioPdf,
    dayByDay: [],
  },

    {
    type: SlideType.nacional,
    isBloqueio: false,
    title: "Curitiba (PR) – O maior Natal do Brasil",
    period: "04 noites",
    initialDate: "11/12/2026",
    finalDate: "15/12/2026",
    parcelValue: 175.0,
    qtdParcel: 12,
    entry: 663.00,
    value: 2683.00,
    include: [
      "Passagem Aéreo ida e volta com franquia de 10Kg;",
      "04 Noites de Hospedagem com café da manhã;",
      "City tour com guia local;",
      "Seguro viagem"      
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",

    ],
    image: NatalCWB,
    imageH: NatalCWBH,
    lamina: NatalCWBL,
    pdf: NatalCWBPdf,
    dayByDay: [],
  },

      {
    type: SlideType.nacional,
    isBloqueio: false,
    title: "Caldas Novas (GO) - O Paraiso das Aguas Termais",
    period: "04 noites",
    initialDate: "23/11/2026",
    finalDate: "27/11/2026",
    parcelValue: 153.0,
    qtdParcel: 12,
    entry: 578.00,
    value: 2340.00,
    include: [
      "Passagem aérea Vitoria x Goiania x Vitoria com Bagagem de 10 kg;",
      "04 Noites de Hospedagem conforme escolha com cafe;",
      "Traslados aeroporto x Hotel x aeroporto - Regular;",
      "Seguro viagem"      
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",

    ],
    image: CaldasNovas,
    imageH: CaldasNovasH,
    lamina: CaldasNovasL,
    pdf: CaldasNovasPdf,
    dayByDay: [],
  },

    {
    type: SlideType.nacional,
    isBloqueio: true,
    title: "Florianópolis (SC) - Super Promo",
    period: "04 noites",
    initialDate: "06/11/2027",
    finalDate: "10/11/2027",
    parcelValue: 125.0,
    qtdParcel: 12,
    entry: 465.0,
    value: 1909.0,
    include: [
      "Passagem aerea ida e volta com franquia de bagagem de 10Kg;",
      "04 Noites de Hospedagem com café da manhã conforme opções;",
      "Transfer in/out - Aeroporto x hotel x Aeroporto;",
      "Seguro de viagem",
    ],
    description: [
      "Pacote não inclui: Taxa de Embarque, Gorjetas, despesas pessoais, alimentação, bebidas e serviços não mencionados acima.",
    ],
    policy: [
      "Pagamento à vista 3% desconto ou até 12x nos cartões de crédito sem juros (passando maquininha empresa)",
      "Para a pré-reserva, obrigatório envio de nome completo, RG, CPF e data de nascimento de todos os passageiros e preenchimento do contrato de aquisição de serviços. A Vaga só é reservada mediante pagamento integral;",
      "Valor do pacote sujeito a reajuste sem prévio aviso e mediante disponibilidade de vagas no ato da reserva;",
      "Os voos poderão sofrer alterações por parte da cia aérea (bloqueio aéreo). A tarifa aérea não permite reembolso.",
      "DOCUMENTOS PARA VIAGEM: Carteira de identidade (RG – recomenda-se emissão menos de 10 anos) em bom estado, CNH – ORIGINAL ou passaporte. Para crianças é aceito a certidão de nascimento    ORIGINAL, quando viajando com um dos pais. *Menores de idade a partir de 12 anos deverão apresentar o RG válido;",
      "Menores viajando com outras pessoas que não sejam os pais deverá apresentar autorização dos dois pais. Documentação, autorizações e vacinas exigidas para o destino é de responsabilidade do passageiro.",
    ],
    image: Fln,
    imageH: FlnH,
    lamina: FlnL,
    pdf: FlnPdf,
    dayByDay: [],
  },

];
